import {
  faArrowDown19,
  faArrowDown91,
  faArrowDownAZ,
  faArrowDownZA,
  faArrowUp19,
  faArrowUp91,
  faArrowUpAZ,
  faArrowUpZA,
  faCalendarAlt,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckSquare,
  faCircleCheck,
  faClipboard,
  faDownload,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFilter,
  faMarker,
  faMinus,
  faSpinner,
  faSquare,
  faTag,
  faTags,
  faThumbsUp,
  faThumbsDown,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  applyCSVProtection,
  checkLoginForError,
  formatBearerToken,
  processData,
} from '../../../../../Common.functions';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { fetchDataAgnostic, postDataAgnostic, putData } from '../../../../../Services/dataApi';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import {
  Badge,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  Popover,
  PopoverBody,
  PopoverHeader,
  Row,
  UncontrolledPopover,
  UncontrolledTooltip,
} from 'reactstrap';
import { clone } from '../../../../../Services/schedule';
import ConfirmModal from '../../../Coordinator/Schedule/ConfirmModal';
import TagPopover from '../TagPopover';
import PreScreenPopover from './PreScreenPopover';
import style from './style';
import './candidateListWithFilters.style.css';
import Swal from 'sweetalert2';
import Loading from 'Body/Statuses/Loading';
import { CandidateStatusIcons, popoverModifiers } from 'enums';
import SelectByFieldPopover from './SelectByFieldPopover/SelectByFieldPopover';
import RezRateTable from 'Body/RezRATE/Common/RezRateTable/RezRateTable';
import { toast } from 'react-toastify';
import { preparePrescreenCSV } from './prescreenCategoryCSV';
import RezRateBanner from '../../../Common/RezRateBanner/RezRateBanner';

// Initialize Day.js plugins
dayjs.extend(utc);
dayjs.extend(timezone);

let typeTimeout = null;

let selectedIndexes = [];
let selectedCandidates = [];
let downloadSelectedOnly = false; // For CSV Exports.

const CandidateListWithFilters = ({
  dataTypes = [],
  candidates = {},
  getCandidates,
  getAllCandidatesData,
  saveResults,
  deleteCandidatesPermanently,
  evaluators = [],
  token,
  activeSeason,
  dContext,
  isInitializedCandidates,
  isGettingAllDetailedCandidates,
  allCandidatesDetails,
  interviewDates = [],
  allCandidatesDetailsError,
  duplicateIssueSummary = {},
  onOpenDuplicateIssuesModal,
}) => {
  const [toggleSwitch, setToggleSwitch] = useState(false);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [deletedCandidates, setDeletedCandidates] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [csvData, setCSVData] = useState([]);
  const [isExportingCSV, setIsExportingCSV] = useState(false);
  const [columns, setColumns] = useState([]);

  const [filter, setFilter] = useState(6);
  const [statusFilter, setStatusFilter] = useState({ label: 'All', value: 6 });
  const [tagFilter, setTagFilter] = useState();
  const [groupsFilter, setGroupsFilter] = useState();

  const [tagChoices, setTagChoices] = useState([]);
  const [groupChoices, setGroupChoices] = useState([]);

  const [userDetails, setUserDetails] = useState();

  const [lastSelectedIndex, setLastSelectedIndex] = useState();
  const [lastSortedField, setLastSortedField] = useState();
  const [lastSortedOrder, setLastSortedOrder] = useState();
  const [previousFilter, setPreviousFilter] = useState(null);

  const [selectAll, setSelectAll] = useState(false);

  const [shiftKeyDown, setShiftKeyDown] = useState(false);

  const [showMarkModal, setShowMarkModal] = useState(false);
  const [showMarkFilter, setShowMarkFilter] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showScheduledNotif, setShowScheduledNotif] = useState(false);
  const [showPreScreen, setShowPreScreen] = useState(false);
  const [showTagsPopover, setShowTagsPopover] = useState(false);
  const [showSelectPopover, setShowSelectPopover] = useState(false);
  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const [showTagFilter, setShowTagFilter] = useState(false);
  const [showGroupFilter, setShowGroupFilter] = useState(false);
  const [showDeletedOnly, setShowDeletedOnly] = useState(false);

  const [showInterviewDatePopover, setShowInterviewDatePopover] = useState();
  const [datesFromSelectedCandidates, setDatesFromselectedCandidates] = useState([]);
  const [enableAutoSlot, setEnableAutoSlot] = useState(false);

  const [stringSelectProperty, setStringSelectProperty] = useState('AAMCID');
  const [selectByString, setSelectBystring] = useState('');
  const [sortStatus, setSortStatus] = useState({ LastName: 'asc' }); // Object containing dataFields and if asc/desc
  const [sortBy, setSortBy] = useState('LastName');
  const [isTyping, setIsTyping] = useState();
  const [isUpdating, setIsUpdating] = useState(false);
  const [showCSVDownloadConfirmModal, setShowCSVDownloadConfirmModal] = useState(false);

  const [toggleRefresh, setToggleRefresh] = useState(false);

  const defaultSortDescending = ['PrescreenScoreAsDecimal', 'FinalScoreAsDecimal'];

  // Refs below are used because state values don't match up with real time keyboard presses.
  const shiftRef = useRef();
  const lastSelectedRef = useRef();
  const filteredCandidatesRef = useRef();
  const tableHeadersRef = useRef(); // used for downloading csv
  const csvScopeRef = useRef();
  const csvExportIdRef = useRef(0);
  const csvDownloadTimeoutRef = useRef();
  csvScopeRef.current = `${dContext.department?.pk_Department}:${dContext.season?.pk_Season}`;
  useEffect(() => {
    return () => {
      csvExportIdRef.current += 1;
      clearTimeout(csvDownloadTimeoutRef.current);
    };
  }, []);
  const isUpdatingRef = useRef();

  const oldSelectedCandidatesRef = useRef([]); // Selected candidates before holding shift. Store them here so we can revert back to them when clicking around holding shift.
  const shiftSelectCandidatesRef = useRef([]); // candidates selected while holding shift. Store them here while clicking around holding shift. Combine with oldSelectedCandidates after clicking checkbox with no shift.

  const filterOptions = [
    'Deleted',
    'Deleted',
    'Imported',
    'Prescreen',
    'Invite',
    'Rejected (Do not recruit)',
    'All',
    'Registered',
    'Candidate Declined',
  ];

  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const history = useHistory();

  const statusStyle = { marginRight: 5, cursor: 'pointer' };

  const {
    confirmed,
    invited,
    markedForInvite,
    pendingInvite,
    prescreen,
    rejected,
    scheduled,
    unconfirmed,
    waitlisted,
    deleted,
    declined,
  } = CandidateStatusIcons;

  const orderedFilterOptions = [
    { label: 'All', value: 6 },
    {
      label: 'Waitlisted',
      value: 11,
      icon: (
        <FontAwesomeIcon
          id={`waitlisted_status_filter`}
          icon={waitlisted.icon}
          style={{ color: waitlisted.color, ...statusStyle }}
        />
      ),
    },
    {
      label: 'Prescreen',
      value: 3,
      icon: (
        <FontAwesomeIcon
          id={`prescreen_status_filter`}
          icon={prescreen.icon}
          style={{ color: prescreen.color, ...statusStyle }}
        />
      ),
    },
    {
      label: 'To Invite',
      value: 4,
      icon: (
        <FontAwesomeIcon
          id={`markedForInvite_status_filter`}
          icon={markedForInvite.icon}
          style={{ color: markedForInvite.color, ...statusStyle }}
        />
      ),
    },
    {
      label: 'Invited',
      value: 10,
      icon: (
        <FontAwesomeIcon
          id={`invited_status_filter`}
          icon={invited.icon}
          style={{ color: invited.color, ...statusStyle }}
        />
      ),
    },
    {
      label: 'Registered',
      value: 7,
      icon: (
        <FontAwesomeIcon
          id={`registered_status_filter`}
          icon={scheduled.icon}
          style={{ color: scheduled.color, ...statusStyle }}
        />
      ),
    },
    // {
    //   label: 'Deleted',
    //   value: 1,
    //   icon: (
    //     <FontAwesomeIcon
    //       id={`rejected_status_filter`}
    //       icon={deleted.icon}
    //       style={{ color: deleted.color, ...statusStyle }}
    //     />
    //   ),
    // },
    {
      label: 'Rejected',
      value: 5,
      icon: (
        <FontAwesomeIcon
          id={`rejected_status_filter`}
          icon={rejected.icon}
          style={{ color: rejected.color, ...statusStyle }}
        />
      ),
    },
    {
      label: 'Declined',
      value: 8,
      icon: (
        <FontAwesomeIcon
          id={`rejected_status_filter`}
          icon={declined.icon}
          style={{ color: declined.color, ...statusStyle }}
        />
      ),
    },
  ];

  const { season, department } = dContext;
  const { AllowPrescreen } = season || {};
  const { EnableGroups, ProgramType } = department || {};

  // 0 = Deleted
  // 1 = Removed
  // 2 = Imported
  // 3 = Prescreen
  // 4 = Invite
  // 5 = Decline

  const options = {
    sortName: 'First', //default sort column name
    sortOrder: 'asc', //default sort order
  };

  useEffect(() => {
    isUpdatingRef.current = isUpdating;

    setFilteredCandidates(clone(filteredCandidates));
  }, [isUpdating]);

  useEffect(() => {
    shiftRef.current = shiftKeyDown;
  }, [shiftKeyDown]);

  useEffect(() => {
    if (dataTypes && dataTypes.enabled) {
      if (dataTypes.enabled.length > 0) {
        setToggleSwitch(!toggleSwitch);
        filterCandidates();
      }
      // makeColumns(dataTypes.enabled);
    }
  }, [dataTypes]);

  useEffect(() => {
    filterCandidates();
  }, [showDeletedOnly]);

  useEffect(() => {
    filteredCandidatesRef.current = filteredCandidates;
    if (tableHeadersRef.current && (!csvData || csvData.length <= 0)) {
      processCSVData();
    }
  }, [JSON.stringify(filteredCandidates)]);

  useEffect(() => {
    filterCandidatesByTag(tagFilter);
  }, [filter]);

  useEffect(() => {
    oldSelectedCandidatesRef.current = [];
    shiftSelectCandidatesRef.current = [];
    lastSelectedRef.current = null;
    setSelectedIndexes([]);
    setSelectedCandidates([]);
    filterCandidatesByTag(tagFilter);
    setDeletedCandidates(
      allCandidatesDetails.filter((candidate) => {
        return candidate.isRemoved;
      }),
    );
    // filterCandidates((newFilteredCandidates) => {
    //   sortUpdatedCandidateList({
    //     newFilteredCandidates,
    //     ignoreSortStatus: true,
    //   });
    // });
  }, [allCandidatesDetails]);

  useEffect(() => {
    window.onkeydown = (e) => {
      if (e.keyCode == 16) {
        e.preventDefault();
        setShiftKeyDown(true);
      }
    };

    window.onkeyup = (e) => {
      if (e.keyCode == 16) {
        e.preventDefault();
        setShiftKeyDown(false);
        //   setLastSelectedIndex(null);
      }
    };

    // if (dContext && dContext.department && dContext.department.ApplicationSystem === 'sf_match') {
    //   setStringSelectProperty('SFMatchID');
    // }
    setIsUpdating(true);
    getAllCandidatesData(() => {
      setIsUpdating(false);
    });
    getUserDetails();
    getTags();
    getGroups();
    getDepartmentSettings();
  }, []);

  useEffect(() => {
    // Track dates, to warn user when scheduling.
    if (selectedCandidates) {
      const dates = [];
      selectedCandidates.forEach((c) => {
        if (c.pk_InterviewDate) {
          dates.push(c.pk_InterviewDate);
        }
      });
      setDatesFromselectedCandidates(dates);
    }
  }, [JSON.stringify(selectedCandidates)]);

  useEffect(() => {
    if (tagFilter) {
      filterCandidatesByTag(tagFilter);
    }
  }, [tagFilter]);

  useEffect(() => {
    if (groupsFilter) {
      filterCandidatesByGroup(groupsFilter);
    }
  }, [groupsFilter]);

  useEffect(() => {
    // setToggleRefresh(!toggleRefresh);
  }, [selectedIndexes, selectedCandidates]);

  const setSelectedIndexes = (newSelectedIndexes) => {
    selectedIndexes = newSelectedIndexes;
  };

  const setSelectedCandidates = (newSelectedCandidates) => {
    selectedCandidates = newSelectedCandidates;
  };

  const processCSVData = (options) => {
    const { candidatesToProcess = filteredCandidates, cb } = options || {};
    const headers = []; // ['Tags'];
    const newCSVData = [];

    tableHeadersRef.current.forEach((h) => {
      if (h.dataKey !== 'xx' && h.dataKey !== 'isSelected') {
        headers.push(h.label);
      }
    });
    newCSVData.push(headers);

    candidatesToProcess.forEach((c, candidateIndex) => {
      const { Tags = [] } = c;
      let tagString = '';
      Tags.forEach((tag) => {
        if (tag.pk_Tag != null) {
          if (tagString == '') {
            tagString = tag.Tag;
          } else {
            tagString += `, ${tag.Tag}`;
          }
        }
      });
      const newRow = []; //[tagString];

      tableHeadersRef.current.forEach((h) => {
        switch (h.dataKey) {
          case 'xx':
            // newRow.push('');
            // Status. Don't render anything.
            break;

          case 'isSelected':
            break;
          case 'createdAt':
            newRow.push(dayjs(c.createdAt).format('MMM DD, YYYY hh:mm A'));
            break;

          case 'PrescreenScoreAsDecimal':
            newRow.push(c.PrescreenScoreAsDecimal ? (c.PrescreenScoreAsDecimal * 100).toFixed(2) : 0);
            break;

          case 'FinalScoreAsDecimal':
            newRow.push(c.FinalScoreAsDecimal ? (c.FinalScoreAsDecimal * 100).toFixed(2) : 0);
            break;

          case 'DateOfInterview':
            const formattedDate = `${c.DateOfInterview ? dayjs(c.DateOfInterview).format('MMM DD, YYYY') : ''}${
              c.Label ? ` (${c.Label})` : ''
            }`;
            newRow.push(formattedDate);
            break;

          case 'EvaluatorCount':
            newRow.push(c.PrescreenAssignedEvaluators ? c.PrescreenAssignedEvaluators.length : 0);
            break;

          case 'Tags':
            newRow.push(tagString);
            break;

          case 'Pre-screener':
            const sortedEvaluators = c.PrescreenAssignedEvaluators.slice().sort((a, b) => {
              const textA = `${a.UserLast ? a.UserLast : ''}, ${a.UserFirst ? a.UserFirst : ''}`;
              const textB = `${b.UserLast ? b.UserLast : ''}, ${b.UserFirst ? b.UserFirst : ''}`;
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            });

            let preScreenerString = '';
            sortedEvaluators.forEach((evaluator) => {
              if (preScreenerString == '') {
                preScreenerString = `${evaluator.UserFirst ? `${evaluator.UserFirst}` : ''} ${
                  evaluator.UserLast ? evaluator.UserLast : ''
                }`;
              } else {
                preScreenerString += `, ${evaluator.UserFirst ? `${evaluator.UserFirst}` : ''} ${
                  evaluator.UserLast ? evaluator.UserLast : ''
                }`;
              }
            });
            newRow.push(preScreenerString);
            break;

          case 'Group':
            newRow.push(c.Group && c.Group.Name ? c.Group.Name : c.Group.GroupName || '');
            break;

          case 'DocumentCoverage':
            const documentCoverage = c.DocumentCoverage || {};
            const presentDocumentCount = documentCoverage.present || 0;
            const totalDocumentCount = documentCoverage.total || 0;
            newRow.push(totalDocumentCount ? `${presentDocumentCount} / ${totalDocumentCount}` : '-');
            break;

          default:
            let newValue = c[h.dataKey];

            if (typeof newValue === 'string') {
              newValue = applyCSVProtection(newValue, c.pk_Candidate === 6141);
            }
            newRow.push(newValue);
            break;
        }
      });
      newCSVData.push(newRow);
    });

    if (cb) {
      cb(newCSVData);
      return;
    }
    setCSVData(newCSVData);
  };

  const downloadCSV = async (candidatesToProcess) => {
    const scope = { pk_Department: department.pk_Department, pk_Season: season.pk_Season };
    const scopeKey = `${scope.pk_Department}:${scope.pk_Season}`;
    const exportId = ++csvExportIdRef.current;
    clearTimeout(csvDownloadTimeoutRef.current);
    const isCurrentScope = () => {
      return csvScopeRef.current === scopeKey && csvExportIdRef.current === exportId;
    };
    const candidatesSnapshot = clone(candidatesToProcess);
    let rows;
    processCSVData({ candidatesToProcess: candidatesSnapshot, cb: (data) => { rows = data; } });
    setIsExportingCSV(true);
    try {
      const data = await preparePrescreenCSV({
        rows,
        candidates: candidatesSnapshot,
        scope,
        isPrescreenEnabled: AllowPrescreen,
        isCurrentScope,
        loadCategories: async (requestedScope) => {
          const token = await getTokenSilently();
          const response = await fetchDataAgnostic('department/season/weightCategories', requestedScope, formatBearerToken(token));
          return response.data;
        },
      });
      if (!isCurrentScope()) { return; }
      setCSVData(data);
      csvDownloadTimeoutRef.current = setTimeout(() => {
        if (!isCurrentScope()) { return; }
        const link = document.getElementById('candidate_list_csv_download');
        if (link) { link.click(); }
        setShowCSVDownloadConfirmModal(false);
      }, 300);
    } catch (error) {
      if (isCurrentScope()) {
        toast.error(error.message && !error.response ? error.message : 'Unable to load prescreen categories. Refresh and try the export again.');
      }
    } finally {
      if (csvExportIdRef.current === exportId) { setIsExportingCSV(false); }
    }
  };

  const getUserDetails = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic('department/user/permissions', null, formatBearerToken(token))
          .then((res) => {
            setUserDetails(res.data);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const selectByStringProperty = (options) => {
    const { stringToSelectBy = '', stringSelectProperty = 'AAMCID' } = options || {};
    const newFilteredCandidates = clone(filteredCandidates);
    // .replace(/\s/g, '') // Global removal of spaces
    const stringsToSearchFor = stringToSelectBy
      .replace(/\s+/g, ',')
      .split(',')
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      }); // To do use \n. repalace comma with \n.

    const newSelectedCandidates = [];
    const newSelectedIndexes = [];
    let selectedCount = 0;
    let toSelectCount = 0;
    stringsToSearchFor.forEach((s) => {
      if (s) {
        toSelectCount++;
      }
    });

    newFilteredCandidates.forEach((c) => {
      c.isSelected = false;
      stringsToSearchFor.forEach((s) => {
        if (!s) {
          return;
        }
        if (stringSelectProperty === 'MedicalSchoolOfGraduation' || stringSelectProperty === 'Email') {
          if (c[stringSelectProperty] && s && c[stringSelectProperty].toLowerCase().indexOf(s.toLowerCase()) >= 0) {
            c.isSelected = true;
            selectedCount++;
            newSelectedCandidates.push(c);
            newSelectedIndexes.push(c.pk_Candidate);
          }
        } else if (c[stringSelectProperty] && s && c[stringSelectProperty].toLowerCase() === s.toLowerCase()) {
          c.isSelected = true;
          selectedCount++;

          newSelectedCandidates.push(c);
          newSelectedIndexes.push(c.pk_Candidate);
        }
      });
    });

    oldSelectedCandidatesRef.current = clone(newSelectedCandidates);
    filteredCandidatesRef.current = clone(newFilteredCandidates);

    setSelectedIndexes(newSelectedIndexes);
    setSelectedCandidates(newSelectedCandidates);

    setShowSelectPopover(false);

    setFilteredCandidates(newFilteredCandidates);
    const countDifference = toSelectCount - selectedCount;
    Swal.fire({
      title: 'Selection!',
      label: `Found and selected ${selectedCount} out of ${toSelectCount} ${toSelectCount > 1 ? 'items' : 'item'}! ${
        countDifference == 0
          ? ''
          : `Unable to select ${countDifference} ${countDifference > 1 ? 'items' : 'item'} as ${
              countDifference > 1 ? 'they are' : 'it is'
            } not on the current filtered list.`
      }`,
      type: 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: `Ok`,
    });
  };

  const getInterviewDatesDEVTEST = () => {
    return getTokenSilently()
      .then((token) => {
        return fetchDataAgnostic(
          'department/interviewDates',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            return res.data;
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getTags = () => {
    // setIsLoading(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/tags',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((res) => {
            setTagChoices(res.data);
            // setIsLoading(false);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getGroups = () => {
    // setIsLoading(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'candidate/groups',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            setGroupChoices(res.data);
            // setIsLoading(false);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getDepartmentSettings = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/settings',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            if (res.data && res.data[0]) {
              setEnableAutoSlot(res.data[0].EnableAutoSlotState);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const scheduleAllCandidatesDEVTEST = async () => {
    const interviewDates = await getInterviewDatesDEVTEST();
    const interviewDatesFormatted = interviewDates.map((interviewDate, i) => {
      const { DateOfInterview, EnableLockedStatus, Label, StartTime, pk_InterviewDate } = interviewDate;
      return {
        DateOfInterview,
        EnableLockedStatus,
        Label,
        StartTime,
        isSelected: true,
        pk_InterviewDate,
        preference: i,
        preferenceOrder: i,
        selected: true,
      };
    });
    const promiseArray = [];
    const promises = selectedCandidates.map((candidate) => {
      const { CandidateUUID } = candidate;
      return postDataAgnostic(
        'candidate/interviewDates',
        { clientID: CandidateUUID, AccessID: '123456' },
        { selectedDates: interviewDatesFormatted },
      )
        .then((results) => {
          return results;
        })
        .catch((err) => {})
        .finally(() => {
          // setIsSending(false);
        });
    });

    return Promise.all(promises)
      .then((result) => {
        alert('Scheudled');
      })
      .catch((err) => {});
  };

  const scheduleSelectedCandidates = (pk_InterviewDate, allowOverbook = false) => {
    setIsUpdating(true);
    getTokenSilently()
      .then((token) => {
        putData(
          'candidate',
          { pk_Department: dContext.department.pk_Department },
          { CandidatePks: selectedIndexes, fieldsToUpdate: { pk_InterviewDate }, allowOverbook },
          formatBearerToken(token),
        )
          .then((results) => {
            // the date was overbooked and did not recieve a boolean of allowOverbook = true
            if (results.data.requiresOverbookPermissions) {
              Swal.fire({
                title: 'Overbook Required',
                label: `The selected date is overbooked. Would you like to overbook the date?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: `No`,
                confirmButtonText: `Yes`,
              }).then((result) => {
                if (result.value) {
                  scheduleSelectedCandidates(pk_InterviewDate, true);
                } else {
                  setIsUpdating(false);
                }
              });
              // setOverbookData({ data: results.data, callback });
              // handleCountUpdate(results.data.candidateCount, fieldsToUpdate.pk_InterviewDate);
              return;
            } else {
              toast.success('Candidates Scheduled Successfully!');

              getAllCandidatesData(() => {
                setIsUpdating(false);
              });
              getCandidates(() => {
                setIsUpdating(false);
              });
            }
          })
          .catch((err) => {
            toast.error('Failed to Schedule Candidates!');
            setIsUpdating(false);
            toast.error(err.message);
          });
      })
      .catch((err) => {
        setIsUpdating(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const handleMessageClick = () => {
    if (selectedIndexes.length === 0) {
      return;
    }
    const pks = selectedIndexes.join(',');
    history.push(`/administrator/communications/sendmessages?pks=${pks}`);
  };

  const sortCSVData = (newSortBy, columnIndex) => {
    const newCSVData = clone(csvData);
    const headers = clone(newCSVData[0]);
    newCSVData.splice(0, 1);
    const newSortStatus = clone(sortStatus);
    const order = newSortStatus[newSortBy];

    setSortBy(newSortBy);
    newCSVData.sort((rowA, rowB) => {
      const a = rowA[columnIndex] || '';
      const b = rowB[columnIndex] || '';
      if (a.toUpperCase() > b.toUpperCase()) {
        return order === 'asc' || order == null ? -1 : 1;
      } else if (b.toUpperCase() > a.toUpperCase()) {
        return order === 'asc' || order == null ? 1 : -1;
      } else {
        return 0;
      }
    });

    newCSVData.splice(0, 0, headers);

    setCSVData(newCSVData);
  };

  const filterCandidates = (callback, options = {}) => {
    const { filterValue = filter } = options;
    const newSelectedIndexes = [];
    const newCandidates = Object.values(allCandidatesDetails);
    const newSelectedCandidates = [];

    // { label: 'Waitlisted', value: 11 },
    // { label: 'Removed', value: 1 },
    // { label: 'Newly Imported', value: 2 }, // Doesn't make sense
    // { label: 'Prescreen', value: 3 },
    // { label: 'To Invite', value: 4 },
    // { label: 'Rejected', value: 5 },
    // { label: 'All', value: 6 },
    // { label: 'Registered', value: 7 },
    // { label: 'Declined', value: 8 },
    // { label: 'Scheduled', value: 9 },
    // { label: 'Invited', value: 10 },

    const newFilteredCandidates = newCandidates.filter((candidate) => {
      const {
        isRemoved,
        isDeleted,
        DateOfInterview,
        IsScheduled,
        EnableMarkedForInvitation,
        EnableMarkedForPrescreen,
        HasBeenSentInvitation,
        HasBeenRejectedForInterview,
        HasDeclinedInterview,
        IsWaitlisted,
      } = candidate;

      const isExisting = (!isRemoved && !isDeleted) || (isRemoved && showDeletedOnly);
      const candidateAddDate = dayjs(candidate.createdAt);
      const isRecentlyAdded = dayjs().diff(candidateAddDate, 'hours') < 48;

      const filterConditions = [
        filterValue == 2 && isExisting && isRecentlyAdded,
        filterValue == 3 && isExisting && EnableMarkedForPrescreen,
        filterValue == 4 && isExisting && EnableMarkedForInvitation && !HasBeenSentInvitation,
        filterValue == 5 && isExisting && HasBeenRejectedForInterview,
        filterValue == 6 && isExisting,
        filterValue == 7 && isExisting && DateOfInterview != null,
        filterValue == 8 && isExisting && HasDeclinedInterview,
        filterValue == 9 && isExisting && IsScheduled,
        filterValue == 10 && isExisting && HasBeenSentInvitation,
        filterValue == 11 && isExisting && IsWaitlisted,
      ];

      if (showDeletedOnly) {
        return isRemoved && filterConditions.some((condition) => condition);
      } else {
        return filterConditions.some((condition) => condition);
      }
    });

    if (callback) {
      callback(newFilteredCandidates);
      return;
    }

    oldSelectedCandidatesRef.current = [];
    setSelectedIndexes(newSelectedIndexes);
    setSelectedCandidates(newSelectedCandidates);
    setSelectAll(false);

    setFilteredCandidates(newFilteredCandidates);
  };

  const clearFilters = () => {
    const defaultStatusFilter = { label: 'All', value: 6 };
    setShowTagFilter(false);
    setShowMarkFilter(false);
    setShowGroupFilter(false);
    setTagFilter(null);
    setGroupsFilter(null);
    setStatusFilter(defaultStatusFilter);
    setFilter(6);

    filterCandidates(
      (newFilteredCandidates) => {
        oldSelectedCandidatesRef.current = [];
        setSelectedIndexes([]);
        setSelectedCandidates([]);
        setSelectAll(false);

        onTableSort('LastName', 'asc', clone(newFilteredCandidates), {
          ignoreSortStatus: true,
        });
      },
      { filterValue: 6 },
    );
  };

  const isFilterHeaderActive = (dataKey) => {
    switch (dataKey) {
      case 'Tags':
        return !!(tagFilter && tagFilter.pk_Tag != null);
      case 'xx':
        return !!(statusFilter && statusFilter.value !== 6);
      case 'Group':
        return !!(groupsFilter && groupsFilter.pk_Group != null);
      default:
        return false;
    }
  };

  const isHeaderActive = (dataKey) => {
    return sortBy === dataKey || isFilterHeaderActive(dataKey);
  };

  const getActiveHeaderStyle = (headerStyle = {}, dataKey) => {
    return isHeaderActive(dataKey) ? { ...headerStyle, ...style.activeHeaderStyle } : headerStyle;
  };

  const getActiveHeaderContentStyle = (dataKey) => {
    return isHeaderActive(dataKey) ? style.activeHeaderContentStyle : {};
  };

  const filterCandidatesByTag = (tag) => {
    const newSelectedIndexes = [];

    filterCandidates((newFilteredCandidates) => {
      sortUpdatedCandidateList({
        newFilteredCandidates,
        ignoreSortStatus: true,
        callback: (toFilter) => {
          const newSelectedCandidates = [];
          const tagFilteredCandidates = toFilter.filter((candidate) => {
            const { Tags = [] } = candidate;

            const tagExists = Tags.find((t) => {
              return tag && t.pk_Tag == tag.pk_Tag;
            });

            return tagExists || !tag || tag.pk_Tag == null;
          });

          oldSelectedCandidatesRef.current = [];
          setSelectedIndexes(newSelectedIndexes);
          setSelectedCandidates(newSelectedCandidates);

          setFilteredCandidates(tagFilteredCandidates);
          setSelectAll(false);
        },
      });
    });
  };

  const filterCandidatesByGroup = (group) => {
    const newSelectedIndexes = [];
    if (!group || group.pk_Group == null) {
      filterCandidates();
      return;
    }

    filterCandidates((newFilteredCandidates) => {
      sortUpdatedCandidateList({
        newFilteredCandidates,
        ignoreSortStatus: true,
        callback: (toFilter) => {
          const newSelectedCandidates = [];
          const groupFilteredCandidates = toFilter.filter((candidate) => {
            const { Group } = candidate;

            return Group.pk_Group == group.pk_Group;
          });

          oldSelectedCandidatesRef.current = [];
          setSelectedIndexes(newSelectedIndexes);
          setSelectedCandidates(newSelectedCandidates);

          setFilteredCandidates(groupFilteredCandidates);
          setSelectAll(false);
        },
      });
    });
  };

  /**
   * Sorts the candidate list as per current sorting status. We use this when updating the candidates, to reset the updated list to the current sorting status. We used to lose sorting when updating candidates.
   */
  const sortUpdatedCandidateList = (options) => {
    const { callback, newFilteredCandidates = [], ignoreSortStatus = false } = options;
    const currentSortBy = sortBy;
    const currentSortDirection = sortStatus[currentSortBy];

    onTableSort(currentSortBy, currentSortDirection, newFilteredCandidates, {
      callback: callback,
      ignoreSortStatus,
    });
  };

  const selectAllBetween = (startId, endId, candidateList, willSelect = true) => {
    const newCandidateList = clone(candidateList ? candidateList : filteredCandidates);
    const newSelectedIndexes = []; // clone(selectedIndexes); // [];
    const startIndex =
      startId != null
        ? newCandidateList.findIndex((item) => {
            return item.pk_Candidate == startId;
          })
        : 0;

    const endIndex = newCandidateList.findIndex((item) => {
      return item.pk_Candidate == endId;
    });

    let startIndexActual = 0;
    let endIndexActual = 0;
    if (startIndex > endIndex) {
      startIndexActual = endIndex;
      endIndexActual = startIndex;
    } else {
      startIndexActual = startIndex;
      endIndexActual = endIndex;
    }

    newCandidateList.forEach((candidate, i) => {
      const pk_toAdd = candidate.pk_Candidate;
      if (i >= startIndexActual && i <= endIndexActual) {
        candidate.isSelected = willSelect;

        if (willSelect) {
          if (newSelectedIndexes.indexOf(pk_toAdd) < 0) {
            newSelectedIndexes.push(pk_toAdd);
          }
        } else {
          if (newSelectedIndexes.indexOf(pk_toAdd) >= 0) {
            newSelectedIndexes.splice(newSelectedIndexes.indexOf(pk_toAdd), 1);
          }
        }
      } else if (i < startIndexActual || i > endIndexActual) {
        if (
          oldSelectedCandidatesRef.current.find((c) => {
            return c.pk_Candidate == candidate.pk_Candidate;
          })
        ) {
          candidate.isSelected = true;
          if (newSelectedIndexes.indexOf(pk_toAdd) < 0) {
            newSelectedIndexes.push(pk_toAdd);
          }
        } else {
          candidate.isSelected = false;
          if (newSelectedIndexes.indexOf(pk_toAdd) >= 0) {
            newSelectedIndexes.splice(newSelectedIndexes.indexOf(pk_toAdd), 1);
          }
        }
      }
    });
    window.getSelection().removeAllRanges();
    return { newSelectedIndexes, newCandidateList };
  };

  const deleteSelected = (callback) => {
    const candidatesToDelete = [];

    selectedIndexes.forEach((pk_Candidate) => {
      candidatesToDelete.push(pk_Candidate);
    });

    deleteCandidatesPermanently({
      candidatesToDelete,
      callback: () => {
        setSelectedIndexes([]);
        setSelectedCandidates([]);

        if (callback) {
          callback();
        }
      },
    });
  };

  const markSelected = (mark, callback) => {
    const candidatesToUpdate = [];
    const fieldsToUpdate = {};

    selectedIndexes.forEach((pk_Candidate) => {
      candidatesToUpdate.push(pk_Candidate);
    });

    switch (mark) {
      case 'Prescreen':
        fieldsToUpdate.EnableMarkedForPrescreen = true;
        setFilter(3);
        break;

      case 'Invite':
        fieldsToUpdate.EnableMarkedForInvitation = true;
        fieldsToUpdate.HasBeenSentInvitation = false;
        break;

      case 'Rejected (Do not recruit)':
        fieldsToUpdate.HasBeenRejectedForInterview = true;
        break;

      case 'Restore':
        fieldsToUpdate.HasBeenRejectedForInterview = false;
        break;

      case 'Remove':
        fieldsToUpdate.isRemoved = true;
        break;

      case 'Delete':
        fieldsToUpdate.isDeleted = true;
      default:
        break;
    }
    setIsUpdating(true);
    saveResults({
      candidatesToUpdate,
      fieldsToUpdate,
      callback: (success) => {
        if (!success) {
          setIsUpdating(false);
          if (callback) callback(false);
          return;
        }
        if (mark === 'Prescreen') {
        } else {
          setSelectedIndexes([]);
          setSelectedCandidates([]);
        }

        getAllCandidatesData(() => {
          toast.success('Edits saved.');
          setIsUpdating(false);
        });
        if (callback) {
          callback();
        }
      },
    });
  };

  const restoreSelected = (filter, callback) => {
    // { label: 'Removed', value: 1 },
    // { label: 'Newly Imported', value: 2 }, // Doesn't make sense
    // { label: 'Prescreen', value: 3 },
    // { label: 'To Invite', value: 4 },
    // { label: 'Rejected', value: 5 },
    // { label: 'All', value: 6 },
    // { label: 'Registered', value: 7 },
    // { label: 'Declined', value: 8 },
    // { label: 'Scheduled', value: 9 },
    // { label: 'Invited', value: 10 },

    const candidatesToUpdate = [];
    const fieldsToUpdate = {};

    selectedIndexes.forEach((pk_Candidate) => {
      candidatesToUpdate.push(pk_Candidate);
    });

    switch (parseInt(filter)) {
      case 1:
        fieldsToUpdate.isRemoved = false;
        break;

      case 5:
        fieldsToUpdate.HasBeenRejectedForInterview = false;
        break;

      case 8:
        fieldsToUpdate.HasDeclinedInterview = false;
        break;

      default:
        break;
    }

    if (showDeletedOnly) {
      fieldsToUpdate.isRemoved = false;
    }

    saveResults({
      candidatesToUpdate,
      fieldsToUpdate,
      callback: (success) => {
        if (!success) {
          setIsUpdating(false);
          if (callback) callback(false);
          return;
        }
        setSelectedIndexes([]);
        setSelectedCandidates([]);

        toast.success('Restored successfuly!');
        if (callback) {
          callback();
        }
      },
    });
  };

  const handleCheckBoxClick = (row) => {
    const { isSelected } = row;
    let newSelectedIndexes = selectedIndexes;
    let newSelectedCandidates = selectedCandidates;

    const prevIndex = lastSelectedRef.current;
    let previousClickedCandidate = filteredCandidatesRef.current
      ? filteredCandidatesRef.current.find((candidate) => {
          return candidate.pk_Candidate == prevIndex;
        })
      : {};
    let willSelect = previousClickedCandidate ? previousClickedCandidate.isSelected : true;

    // Check if clicked item is already in the selected list.
    if (selectedIndexes.includes(row.pk_Candidate)) {
      const guiltyIndex = newSelectedIndexes.indexOf(row.pk_Candidate);
      if (guiltyIndex >= 0) {
        newSelectedIndexes.splice(guiltyIndex, 1);
      }
    } else {
      newSelectedIndexes.push(row.pk_Candidate);
    }

    const guiltyIndex2 = newSelectedCandidates.findIndex((c) => {
      return c.pk_Candidate == row.pk_Candidate;
    });
    if (guiltyIndex2 >= 0) {
      newSelectedCandidates.splice(guiltyIndex2, 1);
    } else {
      newSelectedCandidates.push(row);
    }

    if (shiftRef.current) {
      // click with shift
      const { newSelectedIndexes, newCandidateList } = selectAllBetween(
        prevIndex,
        row.pk_Candidate,
        // filteredCandidatesRef.current,
        filteredCandidates,
        willSelect,
      );

      let allSelected = true;

      newCandidateList.forEach((c) => {
        if (!c.isSelected) {
          allSelected = false;
        }
        if (c.isSelected && !newSelectedCandidates.find((nc) => nc.pk_Candidate == c.pk_Candidate)) {
          newSelectedCandidates.push(c);
        }

        if (!c.isSelected && newSelectedCandidates.find((nc) => nc.pk_Candidate == c.pk_Candidate)) {
          const guiltyIndex = newSelectedCandidates.findIndex((nc) => nc.pk_Candidate == c.pk_Candidate);

          newSelectedCandidates.splice(guiltyIndex, 1);
        }
      });

      shiftSelectCandidatesRef.current = newCandidateList;
      setSelectedIndexes(newSelectedIndexes);
      setSelectedCandidates(newSelectedCandidates);
      setFilteredCandidates(clone(newCandidateList));
      setSelectAll(allSelected);
    } else {
      // click without shift
      newSelectedIndexes = [];

      // Add selected candidates to selected indexes. This is to make sure selectedCandidates and selectedIndexes match... ?
      newSelectedCandidates.forEach((c) => {
        if (!newSelectedIndexes.includes(c.pk_Candidate)) {
          newSelectedIndexes.push(c.pk_Candidate);
        }
      });
      setLastSelectedIndex(row.pk_Candidate);
      lastSelectedRef.current = row.pk_Candidate;

      // Get updated candidate data from whatever form the list is right now. This is to deal with sorted columns and such.
      const newFilteredCandidates = clone(filteredCandidatesRef.current);
      const newCandidate = newFilteredCandidates.find((c) => {
        return c.pk_Candidate == row.pk_Candidate;
      });
      const selectedIndex = newFilteredCandidates.findIndex((c) => {
        return c.pk_Candidate == row.pk_Candidate;
      });

      const candidateExistsInSelectedCandidates = newSelectedCandidates.findIndex((c) => {
        return c.pk_Candidate == row.pk_Candidate;
      });
      const candidateExistsInSelectedIndexes = newSelectedIndexes.findIndex((c) => {
        return c == row.pk_Candidate;
      });

      if (newCandidate.isSelected) {
        if (candidateExistsInSelectedCandidates >= 0) {
          newSelectedCandidates.splice(candidateExistsInSelectedCandidates, 1);
        }

        if (candidateExistsInSelectedIndexes >= 0) {
          newSelectedIndexes.splice(candidateExistsInSelectedCandidates, 1);
        }
      } else {
        if (candidateExistsInSelectedCandidates < 0) {
          newSelectedCandidates.push(row);
        }

        if (candidateExistsInSelectedIndexes < 0) {
          newSelectedIndexes.push(row.pk_Candidate, 1);
        }
      }

      newCandidate.isSelected = !newCandidate.isSelected;
      newFilteredCandidates[selectedIndex] = newCandidate;
      let allSelected = true;

      newFilteredCandidates.forEach((c) => {
        if (!c.isSelected) {
          allSelected = false;

          // if (newSelectedIndexes.includes(c.pk_Candidate)) {
          //   newSelectedIndexes.splice(newSelectedIndexes.indexOf(c.pk_Candidate), 1);
          // }
        }

        // if (c.isSelected) {
        //   if (!newSelectedIndexes.includes(c.pk_Candidate)) {
        //     newSelectedIndexes.push(c.pk_Candidate);
        //   }
        // }
      });

      setSelectedCandidates(newSelectedCandidates);
      setSelectedIndexes(newSelectedIndexes);

      setFilteredCandidates((prevData) => {
        return newFilteredCandidates;
      });

      oldSelectedCandidatesRef.current = clone(newSelectedCandidates);
      shiftSelectCandidatesRef.current = [];
      setSelectAll(allSelected);
    }
  };

  const markBoolean = (data, callback) => {
    const { booleanString, value } = data;
    const candidatesToUpdate = [];
    const fieldsToUpdate = {};

    selectedIndexes.forEach((pk_Candidate) => {
      candidatesToUpdate.push(pk_Candidate);
    });

    fieldsToUpdate[booleanString] = value;

    setIsUpdating(true);
    saveResults({
      candidatesToUpdate,
      fieldsToUpdate,
      callback: (success) => {
        if (!success) {
          setIsUpdating(false);
          if (callback) callback(false);
          return;
        }
        setSelectedIndexes([]);
        setSelectedCandidates([]);
        setIsUpdating(true);
        getAllCandidatesData((err) => {
          if (err) {
            toast.error('Failed to update candidates.');
          } else {
            toast.success('Edits saved.');
          }

          setIsUpdating(false);
        });
        if (callback) {
          callback();
        }
      },
    });
  };

  const renderTagsForCell = (row) => {
    const { Tags = [] } = row || {};
    return Tags.map((tag) => {
      if (tag.pk_Tag != null) {
        return (
          <div key={tag.pk_Tag}>
            <FontAwesomeIcon icon={faTag} style={{ marginRight: 5 }} />
            {tag.Tag}
          </div>
        );
      } else {
      }
    });
  };

  const renderStatusBar = (candidate) => {
    const statuses = [];
    const {
      pk_Candidate,
      EnableMarkedForInvitation,
      EnableMarkedForPrescreen,
      HasBeenSentInvitation,
      IsWaitlisted,
      IsScheduled,
      HasBeenSentConfirmation,
      HasBeenRejectedForInterview,
      DateOfInterview,
    } = candidate;

    if (EnableMarkedForInvitation) {
      statuses.push(
        <>
          <FontAwesomeIcon
            id={`marked_for_invite_candidateList_${pk_Candidate}`}
            icon={markedForInvite.icon}
            style={{ color: markedForInvite.color, ...statusStyle }}
          />
          <UncontrolledTooltip modifiers={popoverModifiers} target={`marked_for_invite_candidateList_${pk_Candidate}`}>
            Marked for Invite - This candidate was marked for Invitation.
          </UncontrolledTooltip>
        </>,
      );
    }

    if (HasBeenSentInvitation) {
      // Invited, waiting response
      statuses.push(
        <>
          <FontAwesomeIcon
            id={`invited_${pk_Candidate}`}
            icon={invited.icon}
            style={{ color: invited.color, ...statusStyle }}
          />
          <UncontrolledTooltip modifiers={popoverModifiers} target={`invited_${pk_Candidate}`}>
            Invited - This candidate has been sent an invitation.
          </UncontrolledTooltip>
        </>,
      );
    } else if (EnableMarkedForInvitation && !HasBeenSentInvitation && !IsWaitlisted && !IsScheduled) {
      // Pending Invi
      statuses.push(
        <>
          <FontAwesomeIcon
            id={`pending_invite_${pk_Candidate}`}
            icon={pendingInvite.icon}
            style={{ color: pendingInvite.color, ...statusStyle }}
          />
          <UncontrolledTooltip modifiers={popoverModifiers} target={`pending_invite_${pk_Candidate}`}>
            Pending Invite - This candidate was marked for Invitation but has not been sent an invite yet.
          </UncontrolledTooltip>
        </>,
      );
    }

    if (IsWaitlisted) {
      statuses.push(
        <>
          <FontAwesomeIcon
            id={`waitlisted_${pk_Candidate}`}
            icon={waitlisted.icon}
            style={{ color: waitlisted.color, ...statusStyle }}
          />
          <UncontrolledTooltip modifiers={popoverModifiers} target={`waitlisted_${pk_Candidate}`}>
            Waitlisted - This candidate is currently waitlisted.
          </UncontrolledTooltip>
        </>,
      );
    }
    if (AllowPrescreen && EnableMarkedForPrescreen) {
      statuses.push(
        <>
          <FontAwesomeIcon
            id={`marked_for_prescreen_${pk_Candidate}`}
            icon={prescreen.icon}
            style={{ color: prescreen.color, ...statusStyle }}
          />
          <UncontrolledTooltip target={`marked_for_prescreen_${pk_Candidate}`} modifiers={popoverModifiers}>
            Marked for Prescreen - This candidate is marked for Prescreen.
          </UncontrolledTooltip>
        </>,
      );
    }

    if (IsScheduled) {
      statuses.push(
        <>
          <FontAwesomeIcon
            id={`confirmation_${pk_Candidate}`}
            icon={HasBeenSentConfirmation ? confirmed.icon : unconfirmed.icon}
            style={{ color: HasBeenSentConfirmation ? confirmed.color : unconfirmed.color, ...statusStyle }}
          />
          <UncontrolledTooltip modifiers={popoverModifiers} target={`confirmation_${pk_Candidate}`}>
            {HasBeenSentConfirmation
              ? 'Confirmation Sent - Candidate has been sent a registration confirmation email.'
              : 'Unconfirmed - Candidate has not been sent a registration confirmation email.'}
          </UncontrolledTooltip>
        </>,
      );

      statuses.push(
        <>
          <FontAwesomeIcon
            id={`scheduled_${pk_Candidate}`}
            icon={scheduled.icon}
            style={{ color: scheduled.color, ...statusStyle }}
          />
          <UncontrolledTooltip modifiers={popoverModifiers} target={`scheduled_${pk_Candidate}`}>
            Scheduled - This candidate is registered for an interview date! (
            {dayjs(DateOfInterview).format('dddd, MMM. DD, YYYY')})
          </UncontrolledTooltip>
        </>,
      );
    }

    if (HasBeenRejectedForInterview) {
      statuses.push(
        <>
          <FontAwesomeIcon
            id={`rejected_${pk_Candidate}`}
            icon={rejected.icon}
            style={{ color: rejected.color, ...statusStyle }}
          />
          <UncontrolledTooltip modifiers={popoverModifiers} target={`rejected_${pk_Candidate}`}>
            Rejected - This candidate was marked as Rejected by Program.
          </UncontrolledTooltip>
        </>,
      );
    }

    return statuses;
  };

  const renderTagFilter = () => {
    const tags = [{ pk_Tag: null, Tag: 'All' }];
    tagChoices.forEach((tag) => {
      const existsIntags = tags.find((t) => {
        return t.pk_Tag != null && t.pk_Tag == tag.pk_Tag;
      });

      if (existsIntags == null) {
        tags.push({ pk_Tag: tag.pk_Tag, Tag: tag.Tag });
      }
    });

    return (
      <Popover
        modifiers={popoverModifiers}
        trigger="legacy"
        target="tags_popover_listTab"
        placementPrefix={'filter bs-popover'}
        isOpen={showTagFilter}
        toggle={() => setShowTagFilter(!showTagFilter)}
      >
        <PopoverHeader>
          {' '}
          <div style={style.spacedBetweenRow}>
            <div style={style.buttonLabel}>Tag Filter</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={() => {
                  setShowTagFilter(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody style={{ height: 300, overflowY: 'auto' }}>
          <div style={style.simpleRow}>
            <div style={style.simpleColumn}>
              {tags.map((tag, i) => {
                const backgroundColor = i % 2 == 0 ? 'white' : '#f2f2f2';

                return (
                  <div
                    style={{
                      ...style.simpleRow,
                      backgroundColor:
                        (tagFilter && tagFilter.pk_Tag == tag.pk_Tag) || (tag.pk_Tag == null && tagFilter == null)
                          ? '#caecfa'
                          : backgroundColor,
                      paddingTop: 5,
                      paddingBottom: 5,
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setTagFilter(tag);
                      setShowTagFilter(false);
                    }}
                  >
                    {tag.Tag}
                  </div>
                );
              })}
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const renderGroupFilter = () => {
    const groups = [{ pk_Group: null, Name: 'All' }];
    groupChoices.forEach((group) => {
      const exists = groups.find((g) => {
        return g.pk_Group != null && g.pk_Group == group.pk_Group;
      });

      if (exists == null) {
        groups.push({ pk_Group: group.pk_Group, Name: group.Name });
      }
    });

    return (
      <Popover
        modifiers={popoverModifiers}
        trigger="legacy"
        target="groups_popover_listTab"
        placementPrefix={'filter bs-popover'}
        isOpen={showGroupFilter}
        toggle={() => setShowGroupFilter(!showGroupFilter)}
      >
        <PopoverHeader>
          {' '}
          <div style={style.spacedBetweenRow}>
            <div style={style.buttonLabel}>Group Filter</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={() => {
                  setShowGroupFilter(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody style={{ height: 300, overflowY: 'auto' }}>
          <div style={style.simpleRow}>
            <div style={style.simpleColumn}>
              {groups.map((group, i) => {
                const backgroundColor = i % 2 == 0 ? 'white' : '#f2f2f2';

                return (
                  <div
                    style={{
                      ...style.simpleRow,
                      backgroundColor:
                        (groupsFilter && groupsFilter.pk_Group == group.pk_Group) ||
                        (group.pk_Group == null && groupsFilter == null)
                          ? '#caecfa'
                          : backgroundColor,
                      paddingTop: 5,
                      paddingBottom: 5,
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setGroupsFilter(group);
                      setShowTagFilter(false);
                    }}
                  >
                    {group.Name}
                  </div>
                );
              })}
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  /**
   * Makes columns based off of dataTypes that are enabled. Also added some speciifc columns here.
   * viableCandidates is for when we want to make columns based off of specific properties from candidates, namely, the AdditionalScoring
   */
  const makeColumns = (data) => {
    const renderScrollableCell = (content, options = {}) => {
      const {
        backgroundColor,
        justifyContent = 'flex-start',
        alignItems = 'flex-start',
        textAlign = 'left',
        maxHeight = 250,
        wrapperStyle = {},
        contentStyle = {},
      } = options;

      return (
        <div
          style={{
            width: '100%',
            maxHeight,
            overflowY: 'auto',
            overflowX: 'hidden',
            display: 'flex',
            justifyContent,
            alignItems,
            backgroundColor,
            ...wrapperStyle,
          }}
        >
          <div
            style={{
              width: '100%',
              textAlign,
              ...contentStyle,
            }}
          >
            {content}
          </div>
        </div>
      );
    };

    const getStickyCellBackgroundColor = (row = {}) => {
      if (row.isSelected) {
        return '#caecfa';
      }

      const rowIndex = row.index != null ? row.index : row.rowIndex != null ? row.rowIndex : 0;
      return rowIndex % 2 === 0 ? '#ffffff' : '#f2f2f2';
    };

    const columns = [
      {
        isDummyField: true,
        dataKey: 'isSelected',
        label: '',
        width: 40,
        style: {
          fontSize: 21,
          left: 0,
          zIndex: 1,
          paddingTop: 2,
          paddingBottom: 2,
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',
          verticalAlign: 'middle',
          paddingTop: 2,
          paddingBottom: 2,
          height: 60,
          width: 40,
          overflowY: 'auto',
          position: 'sticky',
        },
        headerStyle: {
          textAlign: 'center',
          cursor: 'pointer',
          left: 0,
          position: 'sticky',
          backgroundColor: 'var(--rr-surface)',
          verticalAlign: 'middle',
          fontSize: 21,
          zIndex: 1,
          width: 40,
          maxWidth: 40,
        },
        headerFormatter: headerFormatter,
        cellFormatter: (cell, row) => {
          let { isSelected } = row;

          return (
            <div
              key={oldSelectedCandidatesRef.current.length}
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'sticky',
                left: -2,
                backgroundColor: getStickyCellBackgroundColor(row),
              }}
            >
              <FontAwesomeIcon
                icon={isSelected ? faCheckSquare : faSquare}
                style={{
                  ...style.clickable,
                  // cursor: isUpdatingRef.current ? 'not-allowed' : 'pointer',
                  // color: isUpdatingRef.current ? 'gray' : null,
                }}
                onClick={async () => {
                  const isUpdatingActual = isUpdatingRef.current;
                  if (isUpdatingActual) {
                    return;
                  }
                  handleCheckBoxClick(row);
                }}
              />
            </div>
          );
        },
      },
    ];

    const defaultCellStyle = style.cellStyle();
    columns.push({
      dataKey: 'LastName',
      width: 200,
      doSort: true,
      headerStyle: {
        maxWidth: 200,
        minWidth: 200,
        left: 40,
        position: 'sticky',
        zIndex: 3,
        textAlign: 'center',
        cursor: 'pointer',
        verticalAlign: 'middle',
        fontStyle: 'bold',
        backgroundColor: 'var(--rr-surface)',
      },
      // sort: true,
      // sortOrder: sortStatus['LastName'],
      onSort: onRezRateSort,
      sortFunc: () => {
        return 0;
      },
      style: {
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        paddingTop: 2,
        paddingBottom: 2,
        height: 60,
        overflowY: 'auto',
        left: 40,
        maxWidth: 200,
        minWidth: 200,
        zIndex: 1,
        position: 'sticky',
      },
      cellFormatter: (cell, row) => {
        return renderScrollableCell(cell, {
          backgroundColor: getStickyCellBackgroundColor(row),
          textAlign: 'center',
        });
      },
      label: 'Last Name',

      headerAttrs: { id: 'LastName' },
    });

    columns.push({
      dataKey: 'FirstName',
      width: 200,
      // doSort: true,
      headerStyle: {
        minWidth: 200,
        maxWidth: 200,
        left: 240,
        zIndex: 2,
        textAlign: 'center',
        cursor: 'pointer',
        verticalAlign: 'middle',
        fontStyle: 'bold',
        backgroundColor: 'var(--rr-surface)',
      },
      sortOrder: sortStatus['FirstName'],
      doSort: true,
      onSort: onRezRateSort,

      style: {
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        paddingTop: 2,
        paddingBottom: 2,
        height: 60,
        overflowY: 'auto',
        left: 240,
        zIndex: 1,
        maxWidth: 200,
        minWidth: 200,
      },
      cellFormatter: (cell, row) => {
        return renderScrollableCell(cell, {
          backgroundColor: getStickyCellBackgroundColor(row),
          textAlign: 'center',
        });
      },

      label: 'First Name',

      headerAttrs: { id: 'FirstName' },
    });

    columns.push({
      dataKey: 'Tags',
      width: 200,
      headerStyle: {
        minWidth: 200,
        textAlign: 'center',
        width: 'auto',
        cursor: 'pointer',
        verticalAlign: 'middle',
      },
      style: defaultCellStyle,
      label: 'Tags',
      cellFormatter: (cell, row) => {
        return renderScrollableCell(renderTagsForCell(row));
      },
      headerFormatter: (column, colIndex) => {
        return (
          <div
            style={{ ...style.simpleRow, ...getActiveHeaderContentStyle('Tags') }}
            id={'tags_popover_listTab'}
            onClick={() => {
              setShowTagFilter(true);
            }}
          >
            <div style={{ ...style.simpleColumn, width: '100%', textAlign: 'center', justifyContent: 'center' }}>
              <div style={{ ...style.simpleRow, justifyContent: 'center' }}>Tags</div>
              <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: 10 }} />
                <div>{tagFilter ? tagFilter.Tag : 'All'}</div>
              </div>
            </div>
            {renderTagFilter()}
          </div>
        );
      },
    });

    if (EnableGroups) {
      columns.push({
        dataKey: 'Group',
        width: 200,
        doSort: true,
        headerStyle: {
          minWidth: 200,
          textAlign: 'center',
          width: 'auto',
          cursor: 'pointer',
          verticalAlign: 'middle',
        },
        style: defaultCellStyle,
        label: 'Groups',
        cellFormatter: (cell, row) => {
          return renderScrollableCell(row.Group ? row.Group.GroupName : row.GroupName || '');
          // return renderTagsForCell(row);
        },
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ ...style.simpleRow, ...getActiveHeaderContentStyle('Group') }} id={'groups_popover_listTab'}>
              <div style={{ ...style.simpleColumn, width: '100%', textAlign: 'center', justifyContent: 'center' }}>
                <div style={{ ...style.simpleRow, justifyContent: 'center' }}>Groups</div>
                <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
                  <FontAwesomeIcon icon={faFilter} style={{ marginRight: 10 }} />
                  <div>{groupsFilter ? groupsFilter.Name : 'All'}</div>
                </div>
              </div>
              {renderGroupFilter()}
            </div>
          );
        },
      });
    }

    columns.push({
      dataKey: 'xx',
      width: 380,
      headerStyle: {
        minWidth: 380,
        textAlign: 'center',
        width: 'auto',
        cursor: 'pointer',
        verticalAlign: 'middle',
      },
      style: defaultCellStyle,
      headerFormatter: (column, colIndex) => {
        return (
          <div style={{ ...style.simpleRow, ...getActiveHeaderContentStyle('xx') }}>
            <div style={{ ...style.simpleColumn, width: 350, textAlign: 'center', justifyContent: 'center' }}>
              <div style={{ ...style.simpleRow, justifyContent: 'center' }}>Status</div>
              <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
                <InputGroup>
                  <InputGroupText
                    style={{ height: '100%' }}
                    onClick={() => {
                      setShowMarkFilter(!showMarkFilter);
                    }}
                  >
                    <FontAwesomeIcon icon={faFilter} />
                  </InputGroupText>

                  <InputGroupText
                    style={{ height: '100%' }}
                    onClick={() => {
                      setShowMarkFilter(!showMarkFilter);
                    }}
                  >
                    {statusFilter && statusFilter.icon ? statusFilter.icon : <FontAwesomeIcon icon={faMinus} />}
                  </InputGroupText>

                  <Input
                    name="markFilter"
                    id="markFilter_header"
                    type="text"
                    style={style.markFilter}
                    value={statusFilter ? statusFilter.label : 'All'}
                    onFocus={(e) => {
                      // setShowMarkFilter(true);
                      e.target.blur();
                    }}
                    // onChange={(e) => {
                    //   setFilter(e.target.value);
                    // }}
                  />
                  <Popover
                    isOpen={showMarkFilter}
                    target="markFilter_header"
                    trigger="legacy"
                    modifiers={popoverModifiers}
                    toggle={() => {
                      setShowMarkFilter(!showMarkFilter);
                    }}
                  >
                    <PopoverBody>
                      {orderedFilterOptions.map((choice) => {
                        if (choice.label === 'Prescreen' && !AllowPrescreen) return null;
                        return (
                          <Button
                            outline
                            style={{
                              width: '100%',
                              marginBottom: 5,
                              backgroundColor: statusFilter && statusFilter.value == choice.value ? 'var(--rr-primary-soft)' : null,
                            }}
                            color="secondary"
                            onClick={() => {
                              setFilter(choice.value);
                              setStatusFilter(choice);
                              setShowMarkFilter(false);
                            }}
                          >
                            <div
                              key={`${choice.label}_${choice.value}`}
                              style={{ display: 'flex', flexDirection: 'row' }}
                            >
                              <div>{choice.icon ? choice.icon : <FontAwesomeIcon icon={faMinus} />}</div>
                              <div style={{ width: '100%', textAlign: 'center', justifyContent: 'center' }}>
                                {choice.label}
                              </div>
                            </div>
                          </Button>
                        );
                      })}
                    </PopoverBody>
                  </Popover>
                </InputGroup>
              </div>
            </div>
            {renderTagFilter()}
          </div>
        );
      },
      cellFormatter: (cell, row) => {
        return renderScrollableCell(renderStatusBar(row), {
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          contentStyle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        });
      },
      label: 'Status',
    });

    columns.push({
      dataKey: 'DocumentCoverage',
      width: 110,
      headerStyle: {
        minWidth: 110,
        textAlign: 'center',
        width: 'auto',
        verticalAlign: 'middle',
      },
      style: defaultCellStyle,
      label: 'Docs',
      cellFormatter: (cell, row) => {
        const documentCoverage = row.DocumentCoverage || {};
        const presentDocumentCount = documentCoverage.present || 0;
        const totalDocumentCount = documentCoverage.total || 0;
        const coverageLabel = totalDocumentCount ? `${presentDocumentCount} / ${totalDocumentCount}` : '-';
        const isComplete = totalDocumentCount > 0 && presentDocumentCount === totalDocumentCount;

        return renderScrollableCell(
          <button
            type="button"
            className="btn btn-link p-0"
            title="Open Document Checklist"
            style={{
              color: isComplete ? '#198754' : '#0d6efd',
              fontWeight: 'bold',
              textDecoration: 'none',
            }}
            onClick={() => {
              history.push('/administrator/candidates/import_data/document_checklist');
            }}
          >
            {coverageLabel}
          </button>,
          {
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          },
        );
      },
    });

    columns.push({
      dataKey: 'createdAt',
      width: 200,
      headerStyle: {
        minWidth: 200,
        textAlign: 'center',
        width: 'auto',
        cursor: 'pointer',
        verticalAlign: 'middle',
      },
      doSort: true,
      onSort: onRezRateSort,
      style: defaultCellStyle,
      label: 'Created',
      cellFormatter: (cell, row) => {
        return renderScrollableCell(row.createdAt ? dayjs(row.createdAt).format('MMM DD, YYYY hh:mm A') : '', {
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        });
      },
    });

    data.forEach((dataType, i) => {
      const isCustomField = dataType.Name.indexOf('CustomField') == 0;
      if (dataType.Name === 'FirstName' || dataType.Name === 'LastName') {
        return;
      }
      columns.push({
        dataKey: dataType.Name,
        width: dataType.Name === 'HobbiesAndInterests' ? 300 : undefined,
        headerStyle: {
          minWidth: dataType.Name === 'HobbiesAndInterests' ? 300 : 200,
          textAlign: 'center',
          width: 'auto',
          cursor: 'pointer',
          position: 'sticky',
          verticalAlign: 'middle',
          fontStyle: isCustomField ? 'italic' : 'bold',
        },

        doSort: true,
        sortOrder: sortStatus[dataType.Name],
        onSort: onRezRateSort,
        // sortFunc: () => {
        //   return 0;
        // },
        // style: (cell, row, rowIndex) => {
        //   return style.cellStyle({ ...row, rowIndex });
        // },
        style: defaultCellStyle,
        cellFormatter: (cell) => {
          return renderScrollableCell(cell ?? '');
        },
        rawHeader: dataType,
        label: dataType.Alias || dataType.Name,
        headerAttrs: { id: dataType.Name },
      });
    });
    columns.sort((a, b) => {
      return a.SortOrder - b.SortOrder;
    });

    // if (filter == 3) {

    if (AllowPrescreen) {
      columns.splice(3, 0, {
        dataKey: 'Pre-screener',
        headerStyle: {
          minWidth: 200,
          textAlign: 'center',
          width: 'auto',
          cursor: 'pointer',
          verticalAlign: 'middle',
        },
        doSort: true,
        onSort: onRezRateSort,
        style: defaultCellStyle,
        label: 'Prescreen Evaluators',
        cellFormatter: (cell, row) => {
          const sortedEvaluators = row.PrescreenAssignedEvaluators.slice().sort((a, b) => {
            const textA = `${a.UserLast ? a.UserLast : ''}, ${a.UserFirst ? a.UserFirst : ''}`;
            const textB = `${b.UserLast ? b.UserLast : ''}, ${b.UserFirst ? b.UserFirst : ''}`;
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });
          return renderScrollableCell(
            sortedEvaluators.map((evaluator) => {
              return (
                <div key={evaluator.pk_User} style={{ width: '100%', textAlign: 'left' }}>
                  {`${evaluator.UserLast}, ${evaluator.UserFirst}`}
                </div>
              );
            }),
          );
        },
      });
      columns.splice(4, 0, {
        dataKey: 'EvaluatorCount',
        isDummyField: true,
        headerStyle: {
          minWidth: 100,
          textAlign: 'center',
          width: 'auto',
          cursor: 'pointer',
          verticalAlign: 'middle',
        },
        doSort: true,
        onSort: onRezRateSort,
        style: defaultCellStyle,
        label: 'Evaluator Count',
        cellFormatter: (cell, row) => {
          return renderScrollableCell(
            row.PrescreenAssignedEvaluators != null ? row.PrescreenAssignedEvaluators.length : '-',
            {
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            },
          );
        },
      });
    }

    // }

    if (columns.length == 0) {
      columns.push({
        isDummyField: true,
        dataKey: 'towad',
        label: '',
      });
    }

    columns.push({
      dataKey: 'DateOfInterview',
      headerStyle: {
        minWidth: 200,
        textAlign: 'center',
        width: 'auto',
        cursor: 'pointer',
        verticalAlign: 'middle',
      },
      doSort: true,
      onSort: onRezRateSort,
      style: defaultCellStyle,
      label: 'Interview Date',
      cellFormatter: (cell, row) => {
        return renderScrollableCell(
          <>
            <div>{cell ? dayjs(cell).format('MMMM DD, YYYY') : ''}</div>
            <div>{row.Label ? `(${row.Label})` : ''}</div>
          </>,
          {
            justifyContent: 'center',
            textAlign: 'center',
          },
        );
      },
    });

    if (dContext && dContext.season && dContext.season.AllowPrescreen) {
      columns.push({
        dataKey: 'PrescreenScoreAsDecimal',
        headerStyle: {
          minWidth: 200,
          textAlign: 'center',
          width: 'auto',
          cursor: 'pointer',
          verticalAlign: 'middle',
        },
        doSort: true,
        onSort: onRezRateSort,
        style: defaultCellStyle,
        label: 'Prescreen Score',
        cellFormatter: (cell, row) => {
          return renderScrollableCell(cell != null ? (parseFloat(cell) * 100).toFixed(2) : '-', {
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          });
        },
      });
    }

    columns.push({
      dataKey: 'FinalScoreAsDecimal',
      headerStyle: {
        minWidth: 200,
        textAlign: 'center',
        width: 'auto',
        cursor: 'pointer',
        verticalAlign: 'middle',
      },
      doSort: true,
      style: defaultCellStyle,
      onSort: onRezRateSort,
      label: 'Evaluation Score',
      cellFormatter: (cell, row) => {
        return renderScrollableCell(cell != null ? (parseFloat(cell) * 100).toFixed(2) : '-', {
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        });
      },
    });

    const columnsWithActiveHeaderStyle = columns.map((column) => {
      return {
        ...column,
        headerStyle: getActiveHeaderStyle(column.headerStyle, column.dataKey),
      };
    });

    tableHeadersRef.current = columnsWithActiveHeaderStyle;
    // setColumns(columns);
    return columnsWithActiveHeaderStyle;
  };

  const onTableSort = (field, rawOrder, forcedCandidates, options) => {
    const { callback, ignoreSortStatus, stopOnCallback = true } = options || {};
    let order = rawOrder;

    if (ignoreSortStatus) {
      // do nothing, order is forced to be rawOrder
    } else if (sortBy != field) {
      if (!defaultSortDescending.includes(field)) {
        order = 'asc';
      }
    } else {
      if (!defaultSortDescending.includes(field)) {
        order = sortStatus[field] === 'asc' ? 'desc' : 'asc';
      }
    }

    let newFilteredCandidates = clone(forcedCandidates || filteredCandidates);
    if (field === 'PrescreenScoreAsDecimal' || field === 'FinalScoreAsDecimal') {
      newFilteredCandidates.sort((a, b) => {
        if (a[field] == null || a[field] == undefined) {
          return -1;
        }

        if (b[field] == null || b[field] == undefined) {
          return 1;
        }
        return a[field] < b[field] ? 1 : a[field] > b[field] ? -1 : 0;
      });
    } else if (field === 'createdAt') {
      newFilteredCandidates.sort((a, b) => {
        let dateA = dayjs(a[field]);
        let dateB = dayjs(b[field]);

        if (!a[field]) {
          return -1;
        } else if (!b[field]) {
          return 1;
        }

        if (order === 'desc') {
          if (dateA.isBefore(dateB)) {
            return -1;
          } else if (dateB.isBefore(dateA)) {
            return 1;
          } else {
            return a.pk_Candidate - b.pk_Candidate;
          }
        } else {
          if (dateB.isBefore(dateA)) {
            return -1;
          } else if (dateA.isBefore(dateB)) {
            return 1;
          } else {
            return b.pk_Candidate - a.pk_Candidate;
          }
        }
      });
    } else if (field === 'DateOfInterview') {
      // Sort by DateOfInterview
      newFilteredCandidates.sort((a, b) => {
        let dateA = dayjs(`${a[field]} ${a.StartTime || '8:00'}`);
        let dateB = dayjs(`${b[field]} ${b.StartTime || '8:00'}`);

        if (order === 'asc') {
          if (!b[field]) {
            return -1;
          }
          if (!a[field]) {
            return 1;
          }

          if (dateA.isBefore(dateB)) {
            return -1;
          } else if (dateB.isBefore(dateA)) {
            return 1;
          } else {
            return b.pk_Candidate - a.pk_Candidate;
          }
        } else {
          if (!b[field]) {
            return -1;
          }
          if (!a[field]) {
            return 1;
          }

          if (dateB.isBefore(dateA)) {
            return -1;
          } else if (dateA.isBefore(dateB)) {
            return 1;
          } else {
            return a.pk_Candidate - b.pk_Candidate;
          }
        }
      });
    } else if (field === 'EvaluatorCount') {
      newFilteredCandidates.sort((a, b) => {
        let aValue = a.PrescreenAssignedEvaluators ? a.PrescreenAssignedEvaluators.length : null;
        let bValue = b.PrescreenAssignedEvaluators ? b.PrescreenAssignedEvaluators.length : null;

        if (aValue == null) {
          return -1;
        } else if (bValue == null) {
          return 1;
        }

        if (order === 'asc') {
          return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
        } else {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        }
      });
    } else if (field === 'Pre-screener') {
      newFilteredCandidates.sort((a, b) => {
        let textA = null;
        let textB = null;
        if (a.PrescreenAssignedEvaluators) {
          a.PrescreenAssignedEvaluators.sort((a, b) => {
            const textA = `${a.UserLast ? a.UserLast : ''}, ${a.UserFirst ? a.UserFirst : ''}`;
            const textB = `${b.UserLast ? b.UserLast : ''}, ${b.UserFirst ? b.UserFirst : ''}`;
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          }).forEach((e) => {
            if (textA == null) {
              textA = `${e.UserLast}, ${e.UserFirst}`;
            } else {
              textA += `, ${e.UserLast}, ${e.UserFirst}`;
            }
          });
        }

        if (b.PrescreenAssignedEvaluators) {
          b.PrescreenAssignedEvaluators.sort((a, b) => {
            const textA = `${a.UserLast ? a.UserLast : ''}, ${a.UserFirst ? a.UserFirst : ''}`;
            const textB = `${b.UserLast ? b.UserLast : ''}, ${b.UserFirst ? b.UserFirst : ''}`;
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          }).forEach((e) => {
            if (textB == null) {
              textB = `${e.UserLast}, ${e.UserFirst}`;
            } else {
              textB += `, ${e.UserLast}, ${e.UserFirst}`;
            }
          });
        }

        let valueToReturn = 0;

        if (!textA) {
          valueToReturn = order === 'asc' ? 1 : -1;
        } else if (!textB) {
          valueToReturn = order === 'asc' ? -1 : 1;
        } else {
          valueToReturn =
            order === 'asc' ? (textA < textB ? -1 : textA > textB ? 1 : 0) : textA < textB ? 1 : textA > textB ? -1 : 0;
        }

        return valueToReturn;
      });
    } else {
      newFilteredCandidates.sort((a, b) => {
        let textA = a[field] ? a[field].toUpperCase() : '';
        let textB = b[field] ? b[field].toUpperCase() : '';

        let valueToReturn = 0;

        if (order === 'asc') {
          if (!a[field]) {
            valueToReturn = 1;
          } else if (!b[field]) {
            valueToReturn = -1;
          } else {
            valueToReturn = textA < textB ? -1 : textA > textB ? 1 : 0;
          }
        } else {
          if (!a[field]) {
            valueToReturn = -1;
          } else if (!b[field]) {
            valueToReturn = 1;
          } else {
            valueToReturn = textA < textB ? 1 : textA > textB ? -1 : 0;
          }
        }

        if (valueToReturn == 0) {
          if (field === 'LastName') {
            const textA = a['FirstName'] ? a['FirstName'].toUpperCase() : '';
            const textB = b['FirstName'] ? b['FirstName'].toUpperCase() : '';

            if (order === 'asc') {
              if (!textA) {
                valueToReturn = 1;
              } else if (!textB) {
                valueToReturn = -1;
              } else {
                valueToReturn = textA < textB ? -1 : textA > textB ? 1 : 0;
              }
            } else {
              if (!textA) {
                valueToReturn = -1;
              } else if (!textB) {
                valueToReturn = 1;
              } else {
                valueToReturn = textA < textB ? 1 : textA > textB ? -1 : 0;
              }
            }
          }

          if (field === 'FirstName') {
            const textA = a['LastName'] ? a['LastName'].toUpperCase() : '';
            const textB = b['LastName'] ? b['LastName'].toUpperCase() : '';

            if (order === 'asc') {
              if (!textA) {
                valueToReturn = 1;
              } else if (!textB) {
                valueToReturn = -1;
              } else {
                valueToReturn = textA < textB ? -1 : textA > textB ? 1 : 0;
              }
            } else {
              if (!textA) {
                valueToReturn = 1;
              } else if (!textB) {
                valueToReturn = -1;
              } else {
                valueToReturn = textA < textB ? 1 : textA > textB ? -1 : 0;
              }
            }
          }
        }

        return valueToReturn;
      });
    }

    if (callback) {
      callback(newFilteredCandidates, order);
      if (stopOnCallback) {
        return;
      }
    }

    setSortBy(field);
    setSortStatus({ [field]: order });
    filteredCandidatesRef.current = newFilteredCandidates;
    setFilteredCandidates(newFilteredCandidates);
    setLastSortedField(field);
    setLastSortedOrder(order);
  };

  const onRezRateSort = (data) => {
    const { sortDataKey, sortDirection, dataToSort, callback } = data;

    onTableSort(sortDataKey, sortDirection, dataToSort, {
      ignoreSortStatus: true,
      callback: (newData, order) => {
        if (callback) {
          callback(newData, order);
        }
      },
      stopOnCallback: false,
    });
  };

  const renderMarkPopover = () => {
    return (
      <Popover
        modifiers={popoverModifiers}
        placementPrefix="markPopover bs-popover"
        isOpen={showMarkModal}
        trigger="legacy"
        target="mark_button"
        toggle={(e) => {
          if (typeof e.target.className === 'string' && e.target.className.indexOf('swal') >= 0) {
            return;
          }
          if (selectedCandidates && selectedCandidates.length > 0) {
            setShowMarkModal(!showMarkModal);
          }
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div style={style.buttonLabel}>Mark Selected as: </div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={() => {
                  setShowMarkModal(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <div style={style.simpleColumn}>
            <div style={{ ...style.simpleRow, marginBottom: 10 }}>
              <div style={{ ...style.simpleColumn, minWidth: 100, width: '30%', fontWeight: 'bold' }}>Prescreen: </div>
              <div style={{ ...style.simpleColumn, width: '70%' }}>
                <div style={{ ...style.simpleRow, justifyContent: 'right' }}>
                  <div id="prescreen_mark">
                    <Button
                      disabled={isUpdating || !AllowPrescreen}
                      size="sm"
                      color="success"
                      style={{ width: 50, marginRight: 10 }}
                      onClick={() => {
                        Swal.fire({
                          title: 'Are you sure?',
                          text: `You are about to Mark ${
                            selectedCandidates.length > 1 ? selectedCandidates.length : ''
                          } selected candidate${selectedCandidates.length > 1 ? 's' : ''} for Prescreen.`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Yes',
                          cancelButtonText: 'No',
                        })
                          .then((result) => {
                            if (result.value) {
                              markBoolean({ booleanString: 'EnableMarkedForPrescreen', value: true });
                            }
                          })
                          .finally(() => {
                            setShowMarkModal(false);
                          });
                        // markBoolean({ booleanString: 'EnableMarkedForPrescreen', value: true });
                        // setShowMarkModal(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                  </div>

                  <div id="prescreen_unmark">
                    <Button
                      disabled={isUpdating || !AllowPrescreen}
                      size="sm"
                      color="danger"
                      style={{ width: 50 }}
                      onClick={() => {
                        Swal.fire({
                          title: 'Are you sure?',
                          text: `You are about to Unmark ${
                            selectedCandidates.length > 1 ? selectedCandidates.length : ''
                          } selected candidate${selectedCandidates.length > 1 ? 's' : ''} for Prescreen.`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Yes',
                          cancelButtonText: 'No',
                        })
                          .then((result) => {
                            if (result.value) {
                              markBoolean({ booleanString: 'EnableMarkedForPrescreen', value: false });
                            }
                          })
                          .finally(() => {
                            setShowMarkModal(false);
                          });
                        // markBoolean({ booleanString: 'EnableMarkedForPrescreen', value: false });
                        // setShowMarkModal(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </Button>
                  </div>

                  <UncontrolledTooltip modifiers={popoverModifiers} target="prescreen_mark">
                    Mark for Prescreen.
                    {` `}
                    {!AllowPrescreen ? 'Cannot modify - Prescreen with RezRATE is Disabled.' : ''}
                  </UncontrolledTooltip>
                  <UncontrolledTooltip modifiers={popoverModifiers} target="prescreen_unmark">
                    Unmark for Prescreen. {` `}
                    {!AllowPrescreen ? 'Cannot modify - Prescreen with RezRATE is Disabled.' : ''}
                  </UncontrolledTooltip>
                </div>
              </div>
            </div>
            <div style={{ ...style.simpleRow, marginBottom: 10 }}>
              <div style={{ ...style.simpleColumn, minWidth: 100, width: '30%', fontWeight: 'bold' }}>Invitation: </div>
              <div style={{ ...style.simpleColumn, width: '70%' }}>
                <div style={{ ...style.simpleRow, justifyContent: 'right' }}>
                  <div id="invitation_mark">
                    <Button
                      disabled={isUpdating || !AllowPrescreen}
                      size="sm"
                      color="success"
                      style={{ width: 50, marginRight: 10 }}
                      onClick={() => {
                        Swal.fire({
                          title: 'Are you sure?',
                          text: `You are about to Mark ${
                            selectedCandidates.length > 1 ? selectedCandidates.length : ''
                          } selected candidate${selectedCandidates.length > 1 ? 's' : ''} for Invitation.`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Yes',
                          cancelButtonText: 'No',
                        }).then((result) => {
                          if (result.value) {
                            markBoolean({ booleanString: 'EnableMarkedForInvitation', value: true });
                            setShowMarkModal(false);
                          }
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                  </div>
                  <div id="invitation_unmark">
                    <Button
                      disabled={isUpdating || !AllowPrescreen}
                      size="sm"
                      color="danger"
                      style={{ width: 50 }}
                      onClick={() => {
                        Swal.fire({
                          title: 'Are you sure?',
                          text: `You are about to Unmark ${
                            selectedCandidates.length > 1 ? selectedCandidates.length : ''
                          } selected candidate${selectedCandidates.length > 1 ? 's' : ''} for Invitation.`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Yes',
                          cancelButtonText: 'No',
                        }).then((result) => {
                          if (result.value) {
                            markBoolean({ booleanString: 'EnableMarkedForInvitation', value: false });
                            setShowMarkModal(false);
                          }
                        });

                        // markBoolean({ booleanString: 'EnableMarkedForInvitation', value: false });
                        // setShowMarkModal(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </Button>
                  </div>

                  <UncontrolledTooltip modifiers={popoverModifiers} target="invitation_mark">
                    Mark for Invitation. {` `}
                    {!AllowPrescreen ? 'Cannot modify - Prescreen with RezRATE is Disabled.' : ''}
                  </UncontrolledTooltip>
                  <UncontrolledTooltip modifiers={popoverModifiers} target="invitation_unmark">
                    Unmark for Invitation. {` `}
                    {!AllowPrescreen ? 'Cannot modify - Prescreen with RezRATE is Disabled.' : ''}
                  </UncontrolledTooltip>
                </div>
              </div>
            </div>
            <div style={{ ...style.simpleRow, marginBottom: 10 }}>
              <div style={{ ...style.simpleColumn, minWidth: 100, width: '30%', fontWeight: 'bold' }}>Rejected: </div>
              <div style={{ ...style.simpleColumn, width: '70%' }}>
                <div style={{ ...style.simpleRow, justifyContent: 'right' }}>
                  <Button
                    id="rejection_mark"
                    size="sm"
                    disabled={isUpdating}
                    color="danger"
                    style={{ width: '100%', width: 50, marginRight: 10 }}
                    onClick={() => {
                      Swal.fire({
                        title: 'Are you sure?',
                        text: `You are about to Reject ${
                          selectedCandidates.length > 1 ? selectedCandidates.length : ''
                        } selected candidate${selectedCandidates.length > 1 ? 's' : ''}.`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                      }).then((result) => {
                        if (result.value) {
                          markSelected('Rejected (Do not recruit)');
                          setShowMarkModal(false);
                        }
                      });
                    }}
                  >
                    <div style={style.spacedBetweenRow}>
                      <div style={{ ...style.buttonLabel, marginLeft: 5 }}>
                        <FontAwesomeIcon icon={faThumbsDown} />
                        {/* Rejected (Do not recruit) */}
                      </div>
                    </div>
                  </Button>
                  <UncontrolledTooltip modifiers={popoverModifiers} target="rejection_mark">
                    Mark as Rejected
                  </UncontrolledTooltip>
                  <Button
                    id="restore_mark"
                    size="sm"
                    disabled={isUpdating}
                    color="success"
                    style={{ width: '100%', width: 50 }}
                    onClick={() => {
                      Swal.fire({
                        title: 'Are you sure?',
                        text: `You are about to Restore ${
                          selectedCandidates.length > 1 ? selectedCandidates.length : ''
                        } selected candidate${selectedCandidates.length > 1 ? 's' : ''}.`,

                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                      }).then((result) => {
                        if (result.value) {
                          markSelected('Restore');
                          setShowMarkModal(false);
                        }
                      });
                    }}
                  >
                    <div style={style.spacedBetweenRow}>
                      <div style={{ ...style.buttonLabel, marginLeft: 5 }}>
                        <FontAwesomeIcon icon={faThumbsUp} />
                        {/* Rejected (Do not recruit) */}
                      </div>
                    </div>
                  </Button>
                  <UncontrolledTooltip modifiers={popoverModifiers} target="restore_mark">
                    Restore
                  </UncontrolledTooltip>
                </div>
              </div>
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const renderDeleteConfirmation = () => {
    return (
      <ConfirmModal
        title={`Permanently Delete Selected ${selectedCandidates.length > 1 ? 'Items' : 'Item'}`}
        message={`Are you sure you want to permanently delete selected ${
          selectedCandidates.length > 1 ? 'items' : 'item'
        }?`}
        isOpen={showConfirmDelete}
        buttonChoices={
          <>
            <Button color="secondary" style={{ ...style.genButton, backgroundColor: null }}>
              <div
                style={{ ...style.buttonLabel, margin: 0 }}
                onClick={() => {
                  setShowConfirmDelete(false);
                }}
              >
                Cancel
              </div>
            </Button>
            <Button
              color="danger"
              style={{ ...style.genButton, backgroundColor: null }}
              onClick={() => {
                setIsUpdating(true);
                deleteSelected(() => {
                  setShowConfirmDelete(false);
                  getAllCandidatesData(() => {
                    setIsUpdating(false);
                  });
                });
              }}
            >
              <div style={{ ...style.buttonLabel, margin: 0 }}>Yes</div>
            </Button>
          </>
        }
      />
    );
  };

  const renderRemoveConfirmation = () => {
    return (
      <ConfirmModal
        title={`Deactivate Selected ${selectedCandidates.length > 1 ? 'Items' : 'Item'}`}
        message={`Are you sure you want to deactivate selected ${selectedCandidates.length > 1 ? 'items' : 'item'}?`}
        isOpen={showConfirmRemove}
        buttonChoices={
          <>
            <Button color="secondary" style={{ ...style.genButton, backgroundColor: null }}>
              <div
                style={{ ...style.buttonLabel, margin: 0 }}
                onClick={() => {
                  setShowConfirmRemove(false);
                }}
              >
                Cancel
              </div>
            </Button>
            <Button
              color="danger"
              style={{ ...style.genButton, backgroundColor: null }}
              onClick={() => {
                markSelected('Remove', () => {
                  setShowConfirmRemove(false);
                });
              }}
            >
              <div style={{ ...style.buttonLabel, margin: 0 }}>Yes</div>
            </Button>
          </>
        }
      />
    );
  };

  const renderScheduledNotif = () => {
    const scheduledCandidates = selectedCandidates.filter((candidate) => {
      return candidate.DateOfInterview != null;
    });
    let message =
      'Some Candidates have scheduled Interview dates already! Unschedule them before editing their Status. Candidates with Interview Dates: \n';
    scheduledCandidates.forEach((candidate, i) => {
      if (i > 0) {
        message += `, ${candidate.LastName}`;
      } else {
        message += candidate.LastName;
      }
    });
    return (
      <ConfirmModal
        title={'Locked Items!'}
        message={message}
        buttonChoices={
          <Button
            color="primary"
            onClick={() => {
              setShowScheduledNotif(false);
            }}
          >
            Ok
          </Button>
        }
        isOpen={showScheduledNotif}
      />
    );
  };

  const renderPreScreenList = () => {
    return (
      <Popover
        modifiers={popoverModifiers}
        popperClassName="preScreenPopover"
        isOpen={showPreScreen}
        trigger="legacy"
        target="pre_screen_button"
        toggle={() => {
          if (selectedCandidates && selectedCandidates.length > 0) {
            setShowPreScreen(!showPreScreen);
          }
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div style={style.buttonLabel}>Assign Evaluators </div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={() => {
                  setShowPreScreen(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <PreScreenPopover
            evaluators={evaluators}
            token={token}
            selectedCandidates={selectedIndexes}
            activeSeason={activeSeason}
            setShowPreScreen={setShowPreScreen}
            getAllCandidatesData={getAllCandidatesData}
            getCandidates={getCandidates}
            setIsUpdating={setIsUpdating}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderTagsPopover = () => {
    return (
      <Popover
        modifiers={popoverModifiers}
        popperClassName="markPopover"
        isOpen={showTagsPopover}
        trigger="legacy"
        target="tags_button"
        toggle={(e) => {
          if (typeof e.target.className === 'string' && e.target.className.indexOf('swal') >= 0) {
            return;
          }
          if (selectedCandidates && selectedCandidates.length > 0) {
            setShowTagsPopover(!showTagsPopover);
          }
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div style={style.buttonLabel}>Tags</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={() => {
                  setShowTagsPopover(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <TagPopover
            token={token}
            selectedCandidates={selectedCandidates}
            getCandidates={getCandidates}
            getAllCandidatesData={() => {
              setIsUpdating(true);
              getAllCandidatesData(() => {
                setIsUpdating(false);
              });
            }}
            setShowPopover={setShowTagsPopover}
            setParentTags={(newTags) => {
              setTagChoices(newTags);
            }}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderSelectPopover = () => {
    return (
      <Popover
        // modifiers={{
        //   preventOverflow: { boundariesElement: 'viewport' },
        //   flip: {
        //     behavior: ['top', 'right', 'bottom', 'left'],
        //     fallbackPlacements: ['top', 'right', 'bottom', 'left'],
        //   },
        // }}
        modifiers={popoverModifiers}
        placementPrefix="bs-popover markPopover"
        isOpen={showSelectPopover}
        trigger="legacy"
        target="select_by"
        toggle={() => {
          setShowSelectPopover(!showSelectPopover);
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div style={style.buttonLabel}>Select by Field</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={() => {
                  setShowSelectPopover(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <SelectByFieldPopover selectByStringProperty={selectByStringProperty} />
        </PopoverBody>
      </Popover>
    );
  };

  const showRegistrationConfirmation = (interviewDate) => {
    const candidateCount = selectedIndexes.length;
    const candidateLabel = candidateCount === 1 ? 'candidate' : 'candidates';
    const formattedDate = interviewDate.DateOfInterview
      ? dayjs.tz(interviewDate.DateOfInterview, null).format('dddd, MMM. DD, YYYY')
      : '';
    const sessionDetails = [formattedDate, interviewDate.Label].filter(Boolean).join(' - ');

    return Swal.fire({
      title: `Register ${candidateCount} ${candidateCount === 1 ? 'Candidate' : 'Candidates'}?`,
      text: `Are you sure you want to register ${candidateCount} ${candidateLabel} for ${
        sessionDetails || 'the selected session'
      }?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonColor: 'gray',
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Yes, Register',
    });
  };

  const renderDatePickerPopover = () => {
    return (
      <Popover
        modifiers={popoverModifiers}
        placementPrefix="filterPopover bs-popover"
        isOpen={showInterviewDatePopover}
        trigger="legacy"
        target="date_scheduler"
        toggle={() => {
          setShowInterviewDatePopover(!showInterviewDatePopover);
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div>Available Interview Sessions</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowInterviewDatePopover(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <div>
            <div style={{ height: 410, overflowY: 'auto' }}>
              {interviewDates.map((interviewDate, i) => {
                const { CandidateRegistrationLimit = 0, CountOfCandidates = 0 } = interviewDate || {};
                const backgroundColor = i % 2 === 0 ? 'var(--rr-surface-stripe)' : 'var(--rr-surface)';
                return (
                  <div
                    style={{ ...style.dateListItem, backgroundColor }}
                    onClick={() => {
                      // setShowInterviewDatePopover(false);

                      // STEP 1: Check if candidates are being moved from other dates
                      const datesThatAreNotThisDate = datesFromSelectedCandidates.filter(
                        (d) => d != interviewDate.pk_InterviewDate,
                      );

                      // STEP 2: If moving candidates AND automation is ON, check for unlocked sessions FIRST
                      if (datesThatAreNotThisDate.length > 0 && enableAutoSlot) {
                        const unlockedDates = [];

                        selectedCandidates.forEach((candidate) => {
                          if (
                            candidate.pk_InterviewDate &&
                            candidate.pk_InterviewDate !== interviewDate.pk_InterviewDate
                          ) {
                            const candidateDate = interviewDates.find(
                              (d) => d.pk_InterviewDate === candidate.pk_InterviewDate,
                            );
                            if (candidateDate && !candidateDate.EnableLockedStatus) {
                              // Check if we already added this date
                              if (!unlockedDates.find((ud) => ud.pk_InterviewDate === candidateDate.pk_InterviewDate)) {
                                unlockedDates.push(candidateDate);
                              }
                            }
                          }
                        });

                        if (unlockedDates.length > 0) {
                          // SHOW AUTOSLOTTING WARNING FIRST
                          Swal.fire({
                            title: 'Warning!',
                            text:
                              'Moving candidates could create a vacancy for waitlisted candidates to be slotted by automation. We recommend locking any affected sessions before you proceed.',
                            icon: 'warning',
                            showCancelButton: true,
                            cancelButtonColor: 'gray',
                            confirmButtonColor: '#d33',
                            confirmButtonText: 'Proceed Anyway',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              // User confirmed autoslotting warning, now show the registration limits warning
                              showRegistrationConfirmation(interviewDate).then((result) => {
                                if (result.isConfirmed) {
                                  // User confirmed both warnings, now show "Modify Registration?" warning
                                  Swal.fire({
                                    title: 'Modify Registration?',
                                    text: `${datesThatAreNotThisDate.length} selected candidate${
                                      datesThatAreNotThisDate.length > 1 ? 's' : ''
                                    } are already registered for a different date.
                                    `,
                                    icon: 'warning',
                                    showCancelButton: true,
                                    cancelButtonColor: 'gray',
                                    confirmButtonColor: '#d33',
                                    confirmButtonText: `Yes, Modify`,
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      scheduleSelectedCandidates(interviewDate.pk_InterviewDate);
                                      setShowInterviewDatePopover(false);
                                    } else {
                                      setShowInterviewDatePopover(false);
                                    }
                                  });
                                } else {
                                  setShowInterviewDatePopover(false);
                                }
                              });
                            } else {
                              // User cancelled autoslotting warning
                              setShowInterviewDatePopover(false);
                            }
                          });
                          return; // Don't continue with normal flow
                        }
                      }

                      // STEP 3: Normal flow - show registration limits warning first (no autoslotting warning needed)
                      showRegistrationConfirmation(interviewDate).then((result) => {
                        if (result.isConfirmed) {
                          if (datesThatAreNotThisDate.length > 0) {
                            // Show "Modify Registration?" warning
                            Swal.fire({
                              title: 'Modify Registration?',
                              text: `${datesThatAreNotThisDate.length} selected candidate${
                                datesThatAreNotThisDate.length > 1 ? 's' : ''
                              } are already registered for a different date.
                              `,
                              icon: 'warning',
                              showCancelButton: true,
                              cancelButtonColor: 'gray',
                              confirmButtonColor: '#d33',
                              confirmButtonText: `Yes, Modify`,
                            }).then((result) => {
                              if (result.isConfirmed) {
                                scheduleSelectedCandidates(interviewDate.pk_InterviewDate);
                                setShowInterviewDatePopover(false);
                              } else {
                                setShowInterviewDatePopover(false);
                              }
                            });
                          } else {
                            scheduleSelectedCandidates(interviewDate.pk_InterviewDate);
                            setShowInterviewDatePopover(false);
                          }
                        }
                      });
                    }}
                  >
                    <div>
                      {`${dayjs
                        .tz(interviewDate.DateOfInterview, null)
                        .format('dddd, MMM. DD, YYYY')} (${CountOfCandidates || 0}/${CandidateRegistrationLimit || 0})`}
                    </div>
                    <div> {interviewDate.Label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const headerFormatter = (column, colIndex) => {
    // Add Sort logic here
    return (
      <div
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          verticalAlign: 'middle',
          maxWidth: 40,
          width: '100%',
          height: '100%',
          display: 'flex',
          backgroundColor: 'var(--rr-surface)',
        }}
      >
        <FontAwesomeIcon
          icon={selectAll ? faCheckSquare : faSquare}
          style={style.clickable}
          onClick={() => {
            const isUpdatingActual = isUpdatingRef.current;
            if (isUpdatingActual) {
              return;
            }
            const newFilteredCandidates = clone(filteredCandidatesRef.current);
            const newSelectedIndexes = clone(selectedIndexes);
            const newSelectedCandidates = clone(selectedCandidates);

            newFilteredCandidates.forEach((c) => {
              c.isSelected = !selectAll;
              if (!selectAll && !newSelectedIndexes.includes(c.pk_Candidate)) {
                newSelectedIndexes.push(c.pk_Candidate);
                newSelectedCandidates.push(c);
              } else if (selectAll && newSelectedIndexes.includes(c.pk_Candidate)) {
                const guiltyIndex = newSelectedIndexes.indexOf(c.pk_Candidate);
                newSelectedIndexes.splice(guiltyIndex);
                newSelectedCandidates.splice(guiltyIndex);
              }
            });

            oldSelectedCandidatesRef.current = newSelectedCandidates;
            setSelectedIndexes(newSelectedIndexes);
            setSelectedCandidates(newSelectedCandidates);
            setSelectAll(!selectAll);
            setFilteredCandidates(newFilteredCandidates);
          }}
        />
      </div>
    );
  };

  const renderIndicatorLabel = () => {
    let color = 'green';
    let icon = faCircleCheck;
    let message = 'Done.';

    if (isGettingAllDetailedCandidates) {
      if (Object.values(allCandidatesDetails).length > 0) {
        message = 'Updating candidate data. . .';
        icon = faSpinner;
        color = 'gray';
      } else {
        message = 'Loading candidate data. . .';
        icon = faSpinner;
        color = 'gray';
      }
    } else if (allCandidatesDetailsError) {
      message = 'Failed to load additional fields.';
      icon = faExclamationTriangle;
      color = 'red';
    }

    return (
      <div style={{ fontSize: 12, fontWeight: 'bold', color: color }}>
        <FontAwesomeIcon icon={icon} style={{ marginRight: 5 }} spin={isGettingAllDetailedCandidates} />
        {message}
      </div>
    );
  };

  const renderIsUpdatingModal = () => {
    return (
      <Modal
        centered
        isOpen={(isGettingAllDetailedCandidates || isUpdating) && Object.values(allCandidatesDetails).length > 0}
      >
        <Loading
          options={{
            labelText: isGettingAllDetailedCandidates ? 'Updating Display Data. . .' : 'Saving Changes. . .',
          }}
        />
      </Modal>
    );
  };

  const renderCSVDownloadConfirmModal = () => {
    return (
      <ConfirmModal
        title={'Download CSV'}
        message={`Are you sure you want to download the current view as a CSV?`}
        isOpen={showCSVDownloadConfirmModal}
        buttonChoices={
          <>
            <Button
              color="secondary"
              style={{ ...style.genButton, backgroundColor: null }}
              onClick={() => {
                csvExportIdRef.current += 1;
                clearTimeout(csvDownloadTimeoutRef.current);
                setIsExportingCSV(false);
                setShowCSVDownloadConfirmModal(false);
              }}
            >
              <div style={{ ...style.buttonLabel, margin: 0 }}>Cancel</div>
            </Button>
            <Button
              color="primary"
              disabled={isExportingCSV || selectedIndexes.length == 0}
              style={{ ...style.genButton, backgroundColor: null }}
              onClick={() => {
                downloadCSV(filteredCandidates.filter((candidate) => {
                  return selectedIndexes.includes(candidate.pk_Candidate);
                }));
              }}
            >
              <div style={{ ...style.buttonLabel, margin: 0 }}> Selected ({selectedIndexes.length})</div>
            </Button>
            <Button
              color="success"
              disabled={isExportingCSV}
              style={{ ...style.genButton, backgroundColor: null }}
              onClick={() => {
                downloadCSV(filteredCandidates);
              }}
            >
              <div style={{ ...style.buttonLabel, margin: 0 }}>All ({filteredCandidates.length})</div>
            </Button>
          </>
        }
      />
    );
  };

  return (
    <div style={{ height: 'calc(100% - 81px)' }}>
      <RezRateBanner
        message={
          duplicateIssueSummary.affectedCandidateCount > 0 ? (
            <>
              {duplicateIssueSummary.affectedCandidateCount} candidate
              {duplicateIssueSummary.affectedCandidateCount > 1 ? 's have' : ' has'} duplicate identifier issues across
              AAMC ID, SF Match ID, or Email.{' '}
              <b>
                Click to review {duplicateIssueSummary.duplicateGroupCount || 0} duplicate value
                {duplicateIssueSummary.duplicateGroupCount > 1 ? 's' : ''}.
              </b>
            </>
          ) : (
            ''
          )
        }
        isShow={duplicateIssueSummary.affectedCandidateCount > 0}
        backgroundColor="#f4b400"
        textColor="#1f1f1f"
        paddingTop={8}
        paddingBottom={8}
        fontSize={14}
        onClick={onOpenDuplicateIssuesModal}
      />
      <div className="screenSizeWrapper" style={{ paddingBottom: 10 }}>
        <Col sm={12}>
          <Row>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <div
                className="screenSize"
                style={{ display: 'flex', alignItems: 'row', justifyContent: 'space-between', width: '100%' }}
              ></div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', width: '100%' }}>
              <div
                className="screenSize"
                style={{ paddingTop: 2, display: 'flex', alignItems: 'row', flexWrap: 'wrap', justifyContent: 'right' }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    marginTop: 5,
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'row' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                      }}
                    >
                      <Button size="sm" color="info" style={{ marginLeft: 10 }} outline>
                        <div style={style.spacedBetweenRow}>
                          <div style={{ ...style.buttonLabel, marginRight: 10 }}>Selected</div>
                          <Badge color="secondary">
                            {selectedIndexes.length}/{filteredCandidates.length}
                          </Badge>
                        </div>
                      </Button>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                      }}
                    >
                      <Button size="sm" style={{ marginLeft: 10, width: 150 }} id={'select_by'}>
                        <div style={style.spacedBetweenRow}>
                          <div>
                            <FontAwesomeIcon icon={faUsers} />
                          </div>
                          <div style={style.buttonLabel}>Select by Field</div>
                        </div>
                      </Button>
                      {renderSelectPopover()}
                    </div>
                  </div>
                </div>

                {AllowPrescreen ? (
                  <Button
                    size="sm"
                    color="success"
                    style={style.actionButton}
                    disabled={selectedIndexes.length == 0}
                    id="pre_screen_button"
                  >
                    <div id="add_remove_btn" style={style.spacedBetweenRow}>
                      <div>
                        <FontAwesomeIcon icon={faClipboard} />
                      </div>
                      <div style={style.buttonLabel}>Assign/Remove Screeners</div>
                    </div>

                    {selectedIndexes.length == 0 ? (
                      <UncontrolledTooltip modifiers={popoverModifiers} target="add_remove_btn">
                        You must select one or more candidates.
                      </UncontrolledTooltip>
                    ) : null}
                  </Button>
                ) : null}

                {!showDeletedOnly && filter != 5 && filter != 8 ? (
                  <>
                    <Button
                      size="sm"
                      color="secondary"
                      style={{ ...style.actionButton, width: 'auto' }}
                      onClick={clearFilters}
                    >
                      <div style={style.simpleRow}>
                        <div>
                          <FontAwesomeIcon icon={faTimes} />
                        </div>
                        <div style={style.buttonLabel}>Clear Filters</div>
                      </div>
                    </Button>
                    <Button
                      size="sm"
                      color="primary"
                      style={{ ...style.actionButton, width: 'auto' }}
                      disabled={selectedIndexes.length == 0}
                      id="mark_button"
                    >
                      <div style={style.simpleRow}>
                        <div>
                          <FontAwesomeIcon icon={faMarker} />
                        </div>
                        <div style={style.buttonLabel}>Mark Candidate{selectedIndexes.length > 1 ? 's' : null}</div>
                      </div>
                    </Button>
                    {renderMarkPopover()}
                  </>
                ) : (
                  <Button
                    size="sm"
                    color="primary"
                    style={{ ...style.actionButton, width: 'auto' }}
                    disabled={selectedIndexes.length == 0}
                    onClick={() => {
                      restoreSelected(filter, () => {
                        setIsUpdating(true);
                        getAllCandidatesData(() => {
                          setIsUpdating(false);
                        });
                      });
                    }}
                  >
                    <div style={style.simpleRow}>
                      <div>
                        <FontAwesomeIcon icon={faMarker} />
                      </div>
                      <div style={style.buttonLabel}>
                        Restore Candidate{selectedIndexes.length > 1 ? 's' : null} from{' '}
                        {showDeletedOnly ? 'Deactivated' : filterOptions[filter]}
                      </div>
                    </div>
                  </Button>
                )}

                <Button
                  size="sm"
                  color="primary"
                  style={{ ...style.actionButton, width: 'auto' }}
                  disabled={selectedIndexes.length == 0}
                  id="tags_button"
                >
                  <div style={style.simpleRow}>
                    <div>
                      <FontAwesomeIcon icon={faTags} />
                    </div>
                    <div style={style.buttonLabel}>Tag Candidate{selectedIndexes.length > 1 ? 's' : null}</div>
                  </div>
                </Button>
                {renderTagsPopover()}
                <Button
                  size="sm"
                  color={showDeletedOnly ? 'primary' : 'danger'}
                  style={{ ...style.actionButton, width: 'auto', minWidth: showDeletedOnly ? 190 : 240 }}
                  onClick={() => {
                    setShowDeletedOnly(!showDeletedOnly);
                  }}
                >
                  <div style={style.simpleRow}>
                    <div>
                      <FontAwesomeIcon icon={faEye} />
                    </div>
                    <div style={{ ...style.buttonLabel, marginLeft: 0 }}>
                      {showDeletedOnly
                        ? 'View Active Candidates'
                        : `View ${deletedCandidates.length} Deactivated Candidate${
                            deletedCandidates.length > 1 ? 's' : ''
                          }`}
                    </div>
                  </div>
                </Button>
                {(showDeletedOnly && userDetails && userDetails.EnableSuperUser) || filter != 1 ? (
                  <Button
                    size="sm"
                    color="danger"
                    style={{ ...style.actionButton, width: 'auto' }}
                    disabled={selectedIndexes.length == 0}
                    onClick={() => {
                      const scheduledCandidates = selectedCandidates.filter((candidate) => {
                        return candidate.DateOfInterview != null;
                      });
                      let hasScheduledCandidates = scheduledCandidates.length > 0;

                      if (hasScheduledCandidates) {
                        setShowScheduledNotif(true);
                      } else {
                        if (showDeletedOnly) {
                          setShowConfirmDelete(true);
                        } else {
                          setShowConfirmRemove(true);
                        }
                      }
                    }}
                  >
                    <div style={style.spacedBetweenRow}>
                      <div>
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </div>
                      <div style={style.buttonLabel}>
                        {showDeletedOnly
                          ? `Permanently Delete ${selectedCandidates.length > 1 ? 'Candidates' : 'Candidate'}`
                          : `Deactivate ${selectedCandidates.length > 1 ? 'Candidates' : 'Candidate'}`}
                      </div>
                    </div>
                  </Button>
                ) : null}

                <Button
                  size="sm"
                  color="primary"
                  style={{ ...style.actionButton, width: 'auto' }}
                  id="download_button"
                  onClick={() => {
                    setShowCSVDownloadConfirmModal(true);
                  }}
                >
                  <div style={style.simpleRow}>
                    <div>
                      <FontAwesomeIcon icon={faDownload} />
                    </div>
                    <div style={style.buttonLabel}>Download CSV</div>
                  </div>
                </Button>

                <div style={{ visibility: 'hidden' }}>
                  <CSVLink
                    data={csvData}
                    target="_blank"
                    rel="noopener noreferrer"
                    id="candidate_list_csv_download"
                    key={`download_actual_${sortBy}_${sortStatus[sortBy]}`}
                    filename={`${dContext.department.DepartmentName}_Export_Candidates_${dayjs().format(
                      'MMM DD, YYYY hh:mm A',
                    )}`}
                  />
                </div>

                <Button
                  size="sm"
                  disabled={selectedIndexes.length == 0}
                  style={{ ...style.actionButton, width: 'auto' }}
                  id="date_scheduler"
                  color="primary"
                >
                  <div style={style.simpleRow}>
                    <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 10 }} />
                    <div style={style.buttonLabel}>
                      {' '}
                      Register Candidate{selectedCandidates.length > 1 ? 's' : ''}
                      {renderDatePickerPopover()}
                    </div>
                  </div>
                </Button>

                <Button
                  size="sm"
                  color="primary"
                  style={{ ...style.actionButton, width: 'auto' }}
                  disabled={selectedIndexes.length == 0}
                  onClick={handleMessageClick}
                  id="message_button"
                >
                  <div style={style.simpleRow}>
                    <div>
                      <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <div style={style.buttonLabel}>Message Candidate{selectedCandidates.length > 1 ? 's' : ''}</div>
                  </div>
                </Button>
              </div>
            </div>
          </Row>
        </Col>
      </div>
      {renderIndicatorLabel()}
      {isGettingAllDetailedCandidates && Object.values(allCandidatesDetails).length <= 0 ? (
        <div
          style={{
            width: '100%',
            height: 100,
            fontWeight: 'bold',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            marginTop: '20vh',
          }}
        >
          <Loading
            options={{
              labelText: 'Loading. . .',
            }}
          />
        </div>
      ) : (
        <div style={{ width: '100%', height: 'calc(100vh - 400px)' }}>
          {/* <BootstrapTable
            data={clone(filteredCandidates)}
            columns={makeColumns(clone(dataTypes.enabled))}
            keyField="Name"
            options={options}
            noDataIndication={<div style={{ justifyContent: 'center', display: 'flex' }}>No Data!</div>}
            headerWrapperClasses="candidateListTableHeader"
          /> */}
          <RezRateTable
            tableType={'striped'}
            isPaginated={true}
            data={filteredCandidates}
            columns={makeColumns(dataTypes.enabled)}
            striped={true}
            tableBodyHeight={`calc(100vh - 450px)`}
            noDataMessage={<div style={{ justifyContent: 'center', display: 'flex' }}>No Data!</div>}
            rowStyle={(data) => {
              const { index, isSelected } = data;
              const styleActual = {};
              if (isSelected) {
                styleActual.backgroundColor = '#caecfa';
              } else {
                styleActual.backgroundColor = index % 2 == 0 ? '#ffffff' : '#f2f2f2';
              }
              return styleActual;
            }}
          />
        </div>
      )}
      {renderIsUpdatingModal()}
      {renderDeleteConfirmation()}
      {renderRemoveConfirmation()}
      {renderScheduledNotif()}
      {renderCSVDownloadConfirmModal()}
      {AllowPrescreen ? renderPreScreenList() : null}
    </div>
  );
};

export default CandidateListWithFilters;
